import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { WEBSERVICE, SITENAMEALIAS } from "../utils/init";
import { fetchEscrowContractDetails, getAuthToken, getAuthUuid, FetchUsdBtcLedgerAmount } from "../utils/service";
import { showToast } from "../utils/library";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js"; 

const PAYPAL_CLIENT_ID =
  "Aa3Vp7FeH1mAmFI2tLu8CF_P_uqyYY1Q0p2Y2VmewvbtJtWj3KUAZdFeQGscn-0YJAciAq7k5rUZKOcC";

// ─────────────────────────────────────────────────────────────────
// Crypto master list
// ─────────────────────────────────────────────────────────────────
const CRYPTO_MASTER_LIST = [
  { currency_code: "BTC",  currency_name: "Bitcoin",       logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/BTC.png",  network: ["NATIVE"] },
  { currency_code: "ETH",  currency_name: "Ethereum",      logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/ETH.png",  network: ["NATIVE"] },
  { currency_code: "BCH",  currency_name: "Bitcoin Cash",  logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/BCH.png",  network: ["NATIVE"] },
  { currency_code: "LTC",  currency_name: "Litecoin",      logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/LTC.png",  network: ["NATIVE"] },
  { currency_code: "HCX",  currency_name: "Hashcash Coin", logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/HCX.png",  network: ["NATIVE"] },
  { currency_code: "XRP",  currency_name: "Ripple",        logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/XRP.png",  network: ["NATIVE"] },
  { currency_code: "USDT", currency_name: "Tether",        logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/USDT.png", network: ["ERC", "TRC"] },
  { currency_code: "DOGE", currency_name: "Dogecoin",      logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/DOGE.png", network: ["NATIVE"] },
  { currency_code: "USDC", currency_name: "USDC",          logo: "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/USDC.png", network: ["TRC"] },
];

const FUND_METHODS = [
  {
    key: "paypal",
    title: "PayPal",
    desc: "Fast and secure payment via your PayPal account or linked card.",
    icon: "fab fa-paypal",
    logo: "https://www.paypalobjects.com/webstatic/icon/pp258.png",
    color: "#0070e0",
  },
  {
    key: "address",
    title: "By receiving address",
    desc: "Send funds directly to the escrow receiving wallet address.",
    icon: "fas fa-wallet",
    color: "#2563eb",
  },
  {
    key: "bank",
    title: "Bank Transfer",
    desc: "Wire funds directly from your bank account. Processing may take 1–3 days.",
    icon: "fas fa-university",
    color: "#e03535",
  },
];

// ─────────────────────────────────────────────────────────────────
// CSS
// ─────────────────────────────────────────────────────────────────
const CSS = `
.ecf-page { padding: 32px 24px 80px; max-width: 860px; overflow-x: hidden; }

.ecf-back-link { display: inline-flex; align-items: center; gap: 7px; font-size: 13px; font-weight: 600; cursor: pointer; margin-bottom: 22px; color: var(--text-color); border: 1.5px solid var(--body-color-less2); background: var(--body-color-less); padding: 7px 14px; border-radius: 8px; font-family: inherit; opacity: .8; transition: opacity .15s, border-color .15s, background .15s; text-decoration: none; }
.ecf-back-link:hover { opacity: 1; border-color: var(--btn-color); background: color-mix(in srgb, var(--btn-color) 7%, transparent); color: var(--btn-color); text-decoration: none; }
.ecf-back-link .ecf-back-arrow { width: 22px; height: 22px; border-radius: 6px; background: color-mix(in srgb, var(--btn-color) 14%, transparent); color: var(--btn-color); display: inline-flex; align-items: center; justify-content: center; font-size: 11px; flex-shrink: 0; transition: background .15s; }
.ecf-back-link:hover .ecf-back-arrow { background: color-mix(in srgb, var(--btn-color) 24%, transparent); }

.ecf-hdr { margin-bottom: 28px; }
.ecf-title { font-size: 22px; font-weight: 700; letter-spacing: -.4px; color: var(--text-color); margin: 0 0 5px; }
.ecf-sub { font-size: 13px; color: var(--text-color); opacity: .6; margin: 0; }
.ecf-contract-badge { display: inline-flex; align-items: center; gap: 6px; margin-top: 10px; padding: 5px 12px; background: color-mix(in srgb, var(--btn-color) 10%, transparent); border: 1px solid color-mix(in srgb, var(--btn-color) 25%, transparent); border-radius: 20px; font-size: 12px; font-weight: 700; color: var(--btn-color); }

/* ── Section card ── */
.ecf-section { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 12px; padding: 22px; margin-bottom: 20px; }
.ecf-section-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; padding-bottom: 12px; border-bottom: 1px solid var(--body-color-less2); }
.ecf-section-title { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .8px; color: var(--text-color); opacity: .65; margin: 0; display: flex; align-items: center; gap: 8px; }

/* ── Participant card ── */
.ecf-participant { background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 10px; padding: 18px; margin-bottom: 14px; position: relative; }
.ecf-participant:last-child { margin-bottom: 0; }
.ecf-participant-num { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--text-color); opacity: .4; margin-bottom: 14px; }
.ecf-participant-rm { position: absolute; top: 14px; right: 14px; width: 26px; height: 26px; border-radius: 6px; background: rgba(239,68,68,.08); border: 1px solid rgba(239,68,68,.2); color: #f87171; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 12px; transition: all .15s; }
.ecf-participant-rm:hover { background: rgba(239,68,68,.16); }

/* ── Form fields ── */
.ecf-grid-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; }
.ecf-field { display: flex; flex-direction: column; gap: 5px; }
.ecf-label { font-size: 12px; font-weight: 600; color: var(--text-color); opacity: .8; display: flex; align-items: center; gap: 5px; }
.ecf-req { color: #ef4444; }
.ecf-input { width: 100%; height: 40px; background: var(--body-color-less); border: 1.5px solid var(--body-color-less2); border-radius: 8px; padding: 0 14px; color: var(--text-color); font-family: inherit; font-size: 14px; outline: none; transition: border-color .2s, box-shadow .2s; box-sizing: border-box; }
.ecf-input::placeholder { color: var(--text-color); opacity: .4; }
.ecf-input:focus { border-color: var(--btn-color); box-shadow: 0 0 0 3px color-mix(in srgb, var(--btn-color) 12%, transparent); }
.ecf-input.error { border-color: #ef4444; }
.ecf-err { font-size: 11px; color: #ef4444; margin-top: 2px; }
.ecf-pct-row { display: flex; gap: 0; }
.ecf-pct-row .ecf-input { border-radius: 8px 0 0 8px; flex: 1; }
.ecf-pct-suffix { display: flex; align-items: center; justify-content: center; height: 40px; padding: 0 14px; background: var(--body-color-less2); border: 1.5px solid var(--body-color-less2); border-left: none; border-radius: 0 8px 8px 0; font-size: 14px; font-weight: 700; color: var(--text-color); flex-shrink: 0; }

/* ── Add button ── */
.ecf-btn-add { height: 34px; padding: 0 14px; border-radius: 8px; background: color-mix(in srgb, var(--btn-color) 10%, transparent); border: 1.5px dashed color-mix(in srgb, var(--btn-color) 35%, transparent); color: var(--btn-color); font-family: inherit; font-size: 12px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all .15s; }
.ecf-btn-add:hover { background: color-mix(in srgb, var(--btn-color) 18%, transparent); }

/* ── Fund method cards ── */
.ecf-fund-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.ecf-fund-card { position: relative; display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 28px 20px 22px; border-radius: 14px; border: 2px solid var(--body-color-less2); background: var(--body-color); cursor: pointer; transition: all .18s; user-select: none; text-align: center; }
.ecf-fund-card:hover { border-color: var(--ecf-fund-color, var(--btn-color)); background: color-mix(in srgb, var(--ecf-fund-color, var(--btn-color)) 5%, var(--body-color)); }
.ecf-fund-card.selected { border-color: var(--ecf-fund-color, var(--btn-color)); background: color-mix(in srgb, var(--ecf-fund-color, var(--btn-color)) 8%, var(--body-color)); box-shadow: 0 0 0 4px color-mix(in srgb, var(--ecf-fund-color, var(--btn-color)) 15%, transparent); }
.ecf-fund-card input[type="radio"] { position: absolute; opacity: 0; pointer-events: none; }
.ecf-fund-card-icon { width: 56px; height: 56px; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; background: color-mix(in srgb, var(--ecf-fund-color, var(--btn-color)) 14%, transparent); color: var(--ecf-fund-color, var(--btn-color)); transition: background .18s; }
.ecf-fund-card.selected .ecf-fund-card-icon { background: color-mix(in srgb, var(--ecf-fund-color, var(--btn-color)) 22%, transparent); }
.ecf-fund-card-title { font-size: 15px; font-weight: 700; color: var(--text-color); }
.ecf-fund-card-desc { font-size: 12px; color: var(--text-color); opacity: .55; line-height: 1.5; }
.ecf-fund-card-check { position: absolute; top: 12px; right: 12px; width: 20px; height: 20px; border-radius: 50%; border: 2px solid var(--body-color-less2); background: transparent; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #fff; transition: all .18s; }
.ecf-fund-card.selected .ecf-fund-card-check { border-color: var(--ecf-fund-color, var(--btn-color)); background: var(--ecf-fund-color, var(--btn-color)); }
@media (max-width: 700px) { .ecf-fund-grid { grid-template-columns: 1fr; } }

/* ── Fund amount box ── */
.ecf-fund-amount-box { margin-top: 22px; padding: 18px 20px; background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 12px; }
.ecf-fund-amount-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--text-color); opacity: .5; margin-bottom: 8px; }
.ecf-fund-amount-input-wrap { position: relative; }
.ecf-fund-amount-prefix { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); font-size: 14px; font-weight: 700; color: var(--text-color); opacity: .5; pointer-events: none; }
.ecf-fund-amount-field { width: 100%; height: 46px; background: var(--body-color-less); border: 1.5px solid var(--body-color-less2); border-radius: 8px; padding: 0 14px 0 14px; color: var(--text-color); font-family: inherit; font-size: 18px; font-weight: 700; outline: none; box-sizing: border-box; }
.ecf-fund-amount-currency { position: absolute; right: 13px; top: 50%; transform: translateY(-50%); font-size: 12px; font-weight: 700; color: var(--text-color); opacity: .45; pointer-events: none; }

/* ── Divider ── */
.ecf-divider { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.ecf-divider-line { flex: 1; height: 1px; background: var(--body-color-less2); }
.ecf-divider-text { font-size: 11px; font-weight: 600; color: var(--text-color); opacity: .4; white-space: nowrap; }

/* ── Crypto panel ── */
.ecf-crypto-list { border: 1.5px solid var(--body-color-less2); border-radius: 10px; overflow: hidden; max-height: 220px; overflow-y: auto; }
.ecf-crypto-row { display: flex; align-items: center; gap: 10px; padding: 9px 12px; cursor: pointer; border-bottom: 1px solid var(--body-color-less2); transition: background .12s; box-sizing: border-box; }
.ecf-crypto-row:last-child { border-bottom: none; }
.ecf-crypto-row:hover { background: color-mix(in srgb, var(--btn-color) 5%, transparent); }
.ecf-crypto-row.selected { background: color-mix(in srgb, #2563eb 8%, transparent); }
.ecf-crypto-logo { width: 26px; height: 26px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.ecf-crypto-code { font-size: 12px; font-weight: 700; min-width: 44px; color: var(--text-color); }
.ecf-crypto-row.selected .ecf-crypto-code { color: #2563eb; }
.ecf-crypto-name { font-size: 11px; color: var(--text-color); opacity: .5; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ecf-crypto-check { width: 16px; height: 16px; border-radius: 50%; border: 1.5px solid var(--body-color-less2); background: transparent; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all .15s; }
.ecf-crypto-row.selected .ecf-crypto-check { border-color: #2563eb; background: #2563eb; }
.ecf-crypto-equiv { margin-top: 14px; padding: 14px 16px; background: color-mix(in srgb, #2563eb 8%, transparent); border: 1px solid color-mix(in srgb, #2563eb 25%, transparent); border-radius: 10px; display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.ecf-crypto-equiv-label { font-size: 12px; font-weight: 600; color: var(--text-color); opacity: .65; }
.ecf-crypto-equiv-value { font-size: 17px; font-weight: 700; color: #2563eb; white-space: nowrap; }
@keyframes ecf-spin { to { transform: rotate(360deg); } }
.ecf-crypto-spinner { width: 14px; height: 14px; border-radius: 50%; border: 2px solid color-mix(in srgb, #2563eb 25%, transparent); border-top-color: #2563eb; display: inline-block; animation: ecf-spin .7s linear infinite; }
.ecf-network-section { margin-top: 12px; }
.ecf-network-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--text-color); opacity: .5; margin-bottom: 8px; }
.ecf-network-options { display: flex; gap: 10px; }
.ecf-network-opt { flex: 1; display: flex; align-items: center; gap: 9px; padding: 10px 14px; border-radius: 9px; border: 1.5px solid var(--body-color-less2); cursor: pointer; user-select: none; transition: all .15s; }
.ecf-network-opt:has(input:checked) { border-color: #2563eb; background: color-mix(in srgb, #2563eb 8%, transparent); }
.ecf-network-opt input[type="radio"] { accent-color: #2563eb; width: 14px; height: 14px; cursor: pointer; flex-shrink: 0; }
.ecf-network-opt-name { font-size: 13px; font-weight: 700; color: var(--text-color); }
.ecf-network-opt-desc { font-size: 11px; color: var(--text-color); opacity: .45; margin-top: 1px; }

/* ── Bank panel ── */
.ecf-bank-notice { padding: 13px 16px; background: color-mix(in srgb, #2563eb 7%, transparent); border: 1px solid color-mix(in srgb, #2563eb 20%, transparent); border-radius: 10px; margin-bottom: 14px; }
.ecf-bank-notice-title { font-size: 12px; font-weight: 700; color: #2563eb; margin: 0 0 8px; display: flex; align-items: center; gap: 6px; }
.ecf-bank-notice-list { margin: 0; padding: 0 0 0 16px; display: flex; flex-direction: column; gap: 5px; }
.ecf-bank-notice-list li { font-size: 12px; color: var(--text-color); opacity: .7; line-height: 1.5; }
.ecf-bank-details-title { font-size: 12px; font-weight: 700; color: var(--text-color); opacity: .65; margin: 0 0 10px; display: flex; align-items: center; gap: 6px; }
.ecf-bank-table { width: 100%; border-collapse: collapse; border: 1.5px solid var(--body-color-less2); border-radius: 10px; overflow: hidden; }
.ecf-bank-table tr { border-bottom: 1px solid var(--body-color-less2); }
.ecf-bank-table tr:last-child { border-bottom: none; }
.ecf-bank-table td { padding: 9px 14px; font-size: 13px; line-height: 1.45; }
.ecf-bank-table td:first-child { font-weight: 600; color: var(--text-color); opacity: .55; width: 42%; white-space: nowrap; }
.ecf-bank-table td:last-child { font-weight: 700; color: var(--text-color); word-break: break-all; }

/* ── Confirm modal ── */
.ecf-confirm-bg { position: fixed; inset: 0; background: rgba(0,0,0,.65); backdrop-filter: blur(4px); z-index: 1000; display: flex; align-items: center; justify-content: center; opacity: 0; pointer-events: none; transition: opacity .2s; }
.ecf-confirm-bg.open { opacity: 1; pointer-events: all; }
.ecf-confirm-box { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 14px; padding: 28px; width: 400px; max-width: 92vw; transform: translateY(12px); transition: transform .2s; }
.ecf-confirm-bg.open .ecf-confirm-box { transform: translateY(0); }
.ecf-confirm-icon { width: 48px; height: 48px; border-radius: 50%; background: rgba(16,185,129,.12); border: 1.5px solid rgba(16,185,129,.3); display: flex; align-items: center; justify-content: center; font-size: 20px; color: #10b981; margin-bottom: 16px; }
.ecf-confirm-title { font-size: 17px; font-weight: 700; color: var(--text-color); margin: 0 0 8px; }
.ecf-confirm-msg { font-size: 13px; color: var(--text-color); opacity: .7; margin: 0 0 22px; line-height: 1.6; }
.ecf-confirm-actions { display: flex; justify-content: flex-end; gap: 10px; }
.ecf-confirm-cancel-btn { height: 38px; padding: 0 18px; border-radius: 8px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); opacity: .8; font-family: inherit; font-size: 13px; font-weight: 500; cursor: pointer; transition: all .15s; }
.ecf-confirm-cancel-btn:hover { opacity: 1; border-color: var(--text-color); }
.ecf-confirm-ok-btn { height: 38px; padding: 0 22px; border-radius: 8px; border: none; background: #10b981; color: #fff; font-family: inherit; font-size: 13px; font-weight: 700; cursor: pointer; box-shadow: 0 0 12px rgba(16,185,129,.3); transition: filter .15s; }
.ecf-confirm-ok-btn:hover { filter: brightness(1.08); }
.ecf-confirm-ok-btn:disabled { opacity: .45; cursor: not-allowed; filter: none; box-shadow: none; }
.ecf-confirm-terms { display: flex; align-items: flex-start; gap: 10px; margin: 0 0 20px; }
.ecf-confirm-terms input[type="checkbox"] { margin-top: 2px; accent-color: #10b981; width: 15px; height: 15px; flex-shrink: 0; cursor: pointer; }
.ecf-confirm-terms label { font-size: 12.5px; color: var(--text-color); opacity: .8; line-height: 1.55; cursor: pointer; }
.ecf-confirm-terms label a { color: #10b981; text-decoration: underline; }

/* ── Crypto popup modal ── */
.ecf-crypto-bg { position: fixed; inset: 0; background: rgba(0,0,0,.65); backdrop-filter: blur(4px); z-index: 1001; display: flex; align-items: center; justify-content: center; opacity: 0; pointer-events: none; transition: opacity .2s; }
.ecf-crypto-bg.open { opacity: 1; pointer-events: all; }
.ecf-crypto-modal-box { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 16px; padding: 28px 28px 24px; width: 500px; max-width: 94vw; max-height: 88vh; overflow-y: auto; transform: translateY(14px); transition: transform .2s; }
.ecf-crypto-bg.open .ecf-crypto-modal-box { transform: translateY(0); }
.ecf-crypto-modal-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.ecf-crypto-modal-title { font-size: 17px; font-weight: 700; color: var(--text-color); margin: 0; display: flex; align-items: center; gap: 10px; }
.ecf-crypto-modal-close { width: 30px; height: 30px; border-radius: 8px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); opacity: .6; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; transition: all .15s; }
.ecf-crypto-modal-close:hover { opacity: 1; border-color: var(--text-color); }
.ecf-crypto-proceed-btn { width: 100%; height: 44px; border-radius: 10px; border: none; background: #2563eb; color: #fff; font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 0 16px rgba(37,99,235,.3); transition: filter .15s; margin-top: 20px; }
.ecf-crypto-proceed-btn:hover { filter: brightness(1.1); }
.ecf-crypto-proceed-btn:disabled { opacity: .5; cursor: not-allowed; pointer-events: none; }

/* ── Bank popup modal ── */
.ecf-bank-bg { position: fixed; inset: 0; background: rgba(0,0,0,.65); backdrop-filter: blur(4px); z-index: 1001; display: flex; align-items: center; justify-content: center; opacity: 0; pointer-events: none; transition: opacity .2s; }
.ecf-bank-bg.open { opacity: 1; pointer-events: all; }
.ecf-bank-box { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 16px; padding: 28px 28px 24px; width: 500px; max-width: 94vw; transform: translateY(14px); transition: transform .2s; max-height: 90vh; overflow-y: auto; }
.ecf-bank-bg.open .ecf-bank-box { transform: translateY(0); }
.ecf-bank-modal-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.ecf-bank-modal-title { font-size: 17px; font-weight: 700; color: var(--text-color); margin: 0; display: flex; align-items: center; gap: 10px; }
.ecf-bank-modal-close { width: 30px; height: 30px; border-radius: 8px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); opacity: .6; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; transition: all .15s; }
.ecf-bank-modal-close:hover { opacity: 1; border-color: var(--text-color); }

/* ── PayPal popup modal ── */
.ecf-paypal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.65); backdrop-filter: blur(4px); z-index: 1001; display: flex; align-items: center; justify-content: center; opacity: 0; pointer-events: none; transition: opacity .2s; }
.ecf-paypal-bg.open { opacity: 1; pointer-events: all; }
.ecf-paypal-box { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 16px; padding: 28px 28px 24px; width: 440px; max-width: 94vw; transform: translateY(14px); transition: transform .2s; }
.ecf-paypal-bg.open .ecf-paypal-box { transform: translateY(0); }
.ecf-paypal-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.ecf-paypal-title { font-size: 17px; font-weight: 700; color: var(--text-color); margin: 0; display: flex; align-items: center; gap: 10px; }
.ecf-paypal-close { width: 30px; height: 30px; border-radius: 8px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); opacity: .6; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; transition: all .15s; }
.ecf-paypal-close:hover { opacity: 1; border-color: var(--text-color); }
.ecf-paypal-amount-row { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 10px; margin-bottom: 20px; }
.ecf-paypal-amount-label { font-size: 12px; font-weight: 600; color: var(--text-color); opacity: .55; }
.ecf-paypal-amount-value { font-size: 22px; font-weight: 700; color: var(--btn-color); }

/* ── Success ── */
.ecf-success { display: flex; flex-direction: column; align-items: center; padding: 60px 20px; text-align: center; gap: 14px; }
.ecf-success-icon { width: 64px; height: 64px; border-radius: 50%; background: rgba(16,185,129,.12); border: 2px solid rgba(16,185,129,.3); display: flex; align-items: center; justify-content: center; font-size: 26px; color: #10b981; }
.ecf-success-title { font-size: 20px; font-weight: 700; color: var(--text-color); margin: 0; }
.ecf-success-sub { font-size: 13px; color: var(--text-color); opacity: .6; margin: 0; max-width: 380px; line-height: 1.55; }

/* ── Buttons ── */
.ecf-btn-fund { height: 40px; padding: 0 28px; border-radius: 8px; border: none; background: #10b981; color: #fff; font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer; box-shadow: 0 0 16px rgba(16,185,129,.3); transition: filter .15s, transform .15s; display: inline-flex; align-items: center; gap: 8px; }
.ecf-btn-fund:disabled, .ecf-btn-draft:disabled { opacity: .4; cursor: not-allowed; pointer-events: none; box-shadow: none; }
.ecf-btn-fund:hover { filter: brightness(1.08); transform: scale(.98); }
.ecf-btn-next { height: 40px; padding: 0 24px; border-radius: 8px; border: none; background: var(--btn-color); color: #fff; font-family: inherit; font-size: 14px; font-weight: 600; cursor: pointer; box-shadow: 0 0 14px color-mix(in srgb, var(--btn-color) 30%, transparent); transition: filter .15s, transform .15s; display: inline-flex; align-items: center; gap: 7px; }
.ecf-btn-next:hover { filter: brightness(1.1); transform: scale(.98); }
.ecf-btn-draft { height: 40px; padding: 0 20px; border-radius: 8px; border: 1.5px solid var(--body-color-less2); background: transparent; color: var(--text-color); font-family: inherit; font-size: 14px; font-weight: 600; cursor: pointer; transition: all .15s; display: inline-flex; align-items: center; gap: 7px; opacity: .8; }
.ecf-btn-draft:hover { opacity: 1; border-color: var(--btn-color); color: var(--btn-color); background: color-mix(in srgb, var(--btn-color) 6%, transparent); }
.ecf-footer { display: flex; justify-content: space-between; align-items: center; padding-top: 20px; border-top: 1px solid var(--body-color-less2); margin-top: 4px; }

@keyframes ecf-fade-up { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
.ecf-view-in { animation: ecf-fade-up .2s ease; }

@media (max-width: 700px) {
  .ecf-page { padding: 16px 10px 80px; }
  .ecf-grid-3 { grid-template-columns: 1fr; }
  .ecf-fund-grid { grid-template-columns: 1fr; }
}

/* ── Coin selection list ── */
.ecf-coin-list { display: flex; flex-direction: column; border: 1.5px solid var(--body-color-less2); border-radius: 10px; overflow: hidden; max-height: 270px; overflow-y: auto; margin-bottom: 2px; }
.ecf-coin-row { display: flex; align-items: center; gap: 12px; padding: 11px 14px; cursor: pointer; border-bottom: 1px solid var(--body-color-less2); transition: background .12s; user-select: none; }
.ecf-coin-row:last-child { border-bottom: none; }
.ecf-coin-row:hover { background: color-mix(in srgb, #2563eb 5%, transparent); }
.ecf-coin-row.selected { background: color-mix(in srgb, #2563eb 9%, transparent); }
.ecf-coin-logo { width: 30px; height: 30px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.ecf-coin-info { flex: 1; min-width: 0; }
.ecf-coin-code { font-size: 13px; font-weight: 700; color: var(--text-color); }
.ecf-coin-row.selected .ecf-coin-code { color: #2563eb; }
.ecf-coin-name { font-size: 11px; color: var(--text-color); opacity: .5; margin-top: 1px; }
.ecf-coin-radio { width: 17px; height: 17px; border-radius: 50%; border: 2px solid var(--body-color-less2); background: transparent; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all .15s; }
.ecf-coin-row.selected .ecf-coin-radio { border-color: #2563eb; background: #2563eb; }

/* ── Network selector (in modal) ── */
.ecf-net-section { margin-top: 14px; }
.ecf-net-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--text-color); opacity: .5; margin-bottom: 8px; }
.ecf-net-opts { display: flex; gap: 10px; }
.ecf-net-opt { flex: 1; display: flex; align-items: center; gap: 9px; padding: 11px 14px; border-radius: 9px; border: 1.5px solid var(--body-color-less2); cursor: pointer; transition: all .15s; user-select: none; }
.ecf-net-opt:has(input:checked) { border-color: #2563eb; background: color-mix(in srgb, #2563eb 9%, transparent); }
.ecf-net-opt input[type="radio"] { accent-color: #2563eb; width: 14px; height: 14px; cursor: pointer; flex-shrink: 0; }
.ecf-net-opt-name { font-size: 13px; font-weight: 700; color: var(--text-color); }
.ecf-net-opt-desc { font-size: 11px; color: var(--text-color); opacity: .45; margin-top: 1px; }

/* ── Converted amount box ── */
.ecf-crypto-equiv-box { margin-top: 14px; padding: 13px 16px; background: color-mix(in srgb, #2563eb 8%, transparent); border: 1px solid color-mix(in srgb, #2563eb 22%, transparent); border-radius: 10px; display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.ecf-crypto-equiv-label { font-size: 12px; font-weight: 600; color: var(--text-color); opacity: .65; }
.ecf-crypto-equiv-val { font-size: 17px; font-weight: 700; color: #2563eb; white-space: nowrap; }

/* ── Deposit Address modal ── */
.ecf-addr-bg { position: fixed; inset: 0; background: rgba(0,0,0,.7); backdrop-filter: blur(5px); z-index: 1002; display: flex; align-items: center; justify-content: center; opacity: 0; pointer-events: none; transition: opacity .2s; }
.ecf-addr-bg.open { opacity: 1; pointer-events: all; }
.ecf-addr-box { background: var(--body-color-less); border: 1px solid var(--body-color-less2); border-radius: 18px; padding: 28px 28px 26px; width: 460px; max-width: 94vw; max-height: 90vh; overflow-y: auto; transform: translateY(14px); transition: transform .2s; }
.ecf-addr-bg.open .ecf-addr-box { transform: translateY(0); }
.ecf-addr-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 22px; }
.ecf-addr-title { font-size: 17px; font-weight: 700; color: var(--text-color); display: flex; align-items: center; gap: 10px; margin: 0; }
.ecf-addr-close { width: 30px; height: 30px; border-radius: 8px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); opacity: .6; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; transition: all .15s; }
.ecf-addr-close:hover { opacity: 1; border-color: var(--text-color); }
.ecf-addr-coin-row { display: flex; align-items: center; gap: 12px; padding: 14px 16px; background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 10px; margin-bottom: 16px; }
.ecf-addr-coin-logo { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.ecf-addr-coin-name { font-size: 15px; font-weight: 700; color: var(--text-color); }
.ecf-addr-coin-network { font-size: 11px; padding: 2px 8px; border-radius: 10px; background: color-mix(in srgb, #2563eb 12%, transparent); color: #2563eb; font-weight: 600; margin-left: 6px; }
.ecf-addr-amt-row { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: color-mix(in srgb, #10b981 8%, transparent); border: 1px solid color-mix(in srgb, #10b981 22%, transparent); border-radius: 10px; margin-bottom: 18px; }
.ecf-addr-amt-label { font-size: 12px; font-weight: 600; color: var(--text-color); opacity: .6; }
.ecf-addr-amt-val { font-size: 18px; font-weight: 700; color: #10b981; }
.ecf-addr-qr-wrap { display: flex; justify-content: center; margin: 0 0 18px; }
.ecf-addr-qr { width: 180px; height: 180px; border-radius: 12px; border: 3px solid var(--body-color-less2); background: #fff; padding: 6px; display: block; }
.ecf-addr-field-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--text-color); opacity: .5; margin-bottom: 8px; }
.ecf-addr-copy-row { display: flex; align-items: center; gap: 8px; padding: 12px 14px; background: var(--body-color); border: 1.5px solid var(--body-color-less2); border-radius: 10px; transition: border-color .2s, background .2s; }
.ecf-addr-copy-row.copied { border-color: #10b981; background: color-mix(in srgb, #10b981 6%, var(--body-color)); }
.ecf-addr-text { flex: 1; font-size: 12px; font-weight: 600; color: var(--text-color); font-family: monospace; line-height: 1.5; word-break: break-all; }
.ecf-addr-copy-btn { height: 32px; padding: 0 12px; border-radius: 7px; border: 1px solid var(--body-color-less2); background: transparent; color: var(--text-color); font-family: inherit; font-size: 11px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 5px; flex-shrink: 0; transition: all .15s; white-space: nowrap; }
.ecf-addr-copy-btn:hover { border-color: #2563eb; color: #2563eb; }
.ecf-addr-copy-btn.copied { border-color: #10b981; color: #10b981; background: color-mix(in srgb, #10b981 8%, transparent); }
.ecf-addr-notice { margin-top: 14px; padding: 11px 14px; background: color-mix(in srgb, #f59e0b 8%, transparent); border: 1px solid color-mix(in srgb, #f59e0b 22%, transparent); border-radius: 9px; font-size: 12px; color: var(--text-color); line-height: 1.55; display: flex; gap: 9px; align-items: flex-start; }
.ecf-addr-done-btn { width: 100%; height: 44px; border-radius: 10px; border: none; background: #10b981; color: #fff; font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 0 16px rgba(16,185,129,.3); transition: filter .15s; margin-top: 18px; }
.ecf-addr-done-btn:hover { filter: brightness(1.08); }

/* ── Fee breakdown ── */
.ecf-fee-box { margin-top: 16px; border: 1px solid var(--body-color-less2); border-radius: 10px; overflow: hidden; }
.ecf-fee-header { display: flex; align-items: center; gap: 7px; padding: 10px 14px; background: var(--body-color); border-bottom: 1px solid var(--body-color-less2); font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--text-color); opacity: .55; }
.ecf-fee-row { display: flex; align-items: center; justify-content: space-between; padding: 9px 14px; font-size: 13px; color: var(--text-color); background: var(--body-color); border-bottom: 1px solid var(--body-color-less2); }
.ecf-fee-row:last-child { border-bottom: none; }
.ecf-fee-row span:first-child { opacity: .6; }
.ecf-fee-row span:last-child { font-weight: 600; }
.ecf-fee-total { background: color-mix(in srgb, var(--btn-color) 6%, var(--body-color)) !important; }
.ecf-fee-total span { font-weight: 700 !important; font-size: 14px !important; color: var(--btn-color) !important; opacity: 1 !important; }
.ecf-fee-loader { margin-top: 14px; padding: 11px 14px; background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 10px; font-size: 12px; color: var(--text-color); opacity: .55; display: flex; align-items: center; gap: 8px; }

/* ── Polling countdown ── */
.ecf-addr-countdown { margin-top: 14px; padding: 11px 16px; background: var(--body-color); border: 1px solid var(--body-color-less2); border-radius: 10px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ecf-addr-countdown-text { font-size: 12px; color: var(--text-color); opacity: .65; display: flex; align-items: center; gap: 7px; }
.ecf-addr-countdown-num { font-size: 20px; font-weight: 700; color: var(--btn-color); min-width: 32px; text-align: right; font-variant-numeric: tabular-nums; }

/* ── Payment success state ── */
.ecf-addr-success { display: flex; flex-direction: column; align-items: center; padding: 28px 12px 16px; text-align: center; gap: 12px; }
.ecf-addr-success-icon { width: 72px; height: 72px; border-radius: 50%; background: rgba(16,185,129,.12); border: 2px solid rgba(16,185,129,.3); display: flex; align-items: center; justify-content: center; font-size: 30px; color: #10b981; animation: ecf-pop .35s cubic-bezier(.34,1.56,.64,1); }
@keyframes ecf-pop { from { transform: scale(.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }
.ecf-addr-success-title { font-size: 20px; font-weight: 700; color: var(--text-color); margin: 0; }
.ecf-addr-success-sub { font-size: 13px; color: var(--text-color); opacity: .6; margin: 0; line-height: 1.6; max-width: 340px; }
.ecf-addr-success-btn { width: 100%; height: 44px; border-radius: 10px; border: none; background: #10b981; color: #fff; font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 0 18px rgba(16,185,129,.35); transition: filter .15s; margin-top: 8px; }
.ecf-addr-success-btn:hover { filter: brightness(1.08); }
`;

// ─────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────
const empty = (v) => !v || !String(v).trim();

function fmtMoney(n, currency = "USD") {
  return `${currency} ${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function fmtAmt(n) {
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function fmtPct(n) {
  return n % 1 === 0 ? n : n.toFixed(1);
}

// ─────────────────────────────────────────────────────────────────
// Field wrapper
// ─────────────────────────────────────────────────────────────────
function Field({ label, req, error, children }) {
  return (
    <div className="ecf-field">
      <label className="ecf-label">
        {label}
        {req && <span className="ecf-req">*</span>}
      </label>
      {children}
      {error && <span className="ecf-err">{error}</span>}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────
export default function EscrowContractFund() {
  const history = useHistory();
  const { contractId } = useParams();
  const homeCurrency = localStorage.getItem(SITENAMEALIAS + "_home_currency") || "USD";

  // ── State ────────────────────────────────────────────────────
  const [payers, setPayers] = useState([]);
  const [youContribution, setYouContribution] = useState("");
  const [fundTotalAmount, setFundTotalAmount] = useState("");
  const [fundMethod, setFundMethod] = useState("");
  const [errors, setErrors] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showPaypalModal, setShowPaypalModal] = useState(false);
  const [showBankModal, setShowBankModal] = useState(false);
  const [showCryptoModal, setShowCryptoModal] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false);
  const [contractCurrency, setContractCurrency] = useState(homeCurrency);
  const [submitted, setSubmitted] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [contractCreatedBy, setContractCreatedBy] = useState(null);
  const [contractStatus, setContractStatus]       = useState(null);
  const [contractNumericId, setContractNumericId] = useState(null);
  const [payerParticipants, setPayerParticipants] = useState([]);
  const [myParticipantId, setMyParticipantId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // Crypto selection state (shared between modal selection + price fetch)
  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [cryptoConvertedAmt, setCryptoConvertedAmt] = useState(null);
  const [cryptoPriceLoading, setCryptoPriceLoading] = useState(false);

  // Crypto list fetched from API (currency_type === 2)
  const [cryptoList, setCryptoList] = useState([]);
  const [cryptoListLoading, setCryptoListLoading] = useState(false);

  // Deposit address modal
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [depositAddress, setDepositAddress] = useState("");
  const [depositMemo, setDepositMemo] = useState("");
  const [depositAddressLoading, setDepositAddressLoading] = useState(false);
  const [addressCopied, setAddressCopied] = useState(false);
  const [memoCopied, setMemoCopied] = useState(false);
  const [addrPaymentStatus, setAddrPaymentStatus] = useState(null);
  const [addrCountdown, setAddrCountdown] = useState(15);
  const addrCountdownRef = useRef(null);
  const [homeCurrencyId, setHomeCurrencyId] = useState(null);
  const [feeData, setFeeData] = useState(null);
  const [feeLoading, setFeeLoading] = useState(false);
  const [feeError, setFeeError] = useState(null);

  // Minimum funding amount — always 100 USD, converted to contractCurrency
  const MIN_FUND_USD = 100;
  const [minFundAmount, setMinFundAmount] = useState(MIN_FUND_USD);
  const [minAmountLoading, setMinAmountLoading] = useState(false);

  // ── Derived values ───────────────────────────────────────────
  const totalAmt       = parseFloat(fundTotalAmount) || 0;
  const youPct         = parseFloat(youContribution) || 0;
  const youAmt         = totalAmt > 0 ? (totalAmt * youPct / 100) : 0;
  const coPayerTotal   = payers.reduce((sum, p) => sum + (parseFloat(p.contribution) || 0), 0);
  const needsNetwork   = ["USDT", "USDC"].includes(selectedCrypto);

  const myMerchantId = parseInt(localStorage.getItem(SITENAMEALIAS + "_merchant_id"), 10) || 0;
  const myEmail      = (localStorage.getItem(SITENAMEALIAS + "_email") || "").toLowerCase();

  // Fallback payer base: find the current user's participant entry.
  // Try email match first, then also check userId/merchantId in case the API
  // returns those fields for participant records.
  const myParticipant = payerParticipants.find((p) =>
    (myEmail && (p.email || "").toLowerCase() === myEmail) ||
    (myMerchantId && (Number(p.userId) === myMerchantId || Number(p.merchantId) === myMerchantId))
  );
  const myParticipantPct = myParticipant
    ? (myParticipant.sharePercent != null ? Number(myParticipant.sharePercent) : (myParticipant.contributionPercentage != null ? Number(myParticipant.contributionPercentage) : 0))
    : 0;

  // Heuristic fallback when the user cannot be identified by email or userId:
  // look at unfunded participants' allocations. If they all share the SAME
  // percentage (e.g. equal 50/50 split), that amount is unambiguous for any
  // remaining payer. Also handles the single-remaining-payer case.
  const unfundedPcts = !myParticipant
    ? payerParticipants
        .filter((p) => p.isFunded !== "YES")
        .map((p) => p.sharePercent != null ? Number(p.sharePercent) : (p.contributionPercentage != null ? Number(p.contributionPercentage) : 0))
        .filter((pct) => pct > 0)
    : [];
  const inferredPct =
    unfundedPcts.length === 1
      ? unfundedPcts[0]
      : (unfundedPcts.length > 1 && unfundedPcts.every((p) => p === unfundedPcts[0]) ? unfundedPcts[0] : 0);

  // The definitive amount this user should pay
  const payerBase =
    youPct > 0 ? youAmt
    : myParticipantPct > 0 ? (totalAmt * myParticipantPct / 100)
    : inferredPct > 0 ? (totalAmt * inferredPct / 100)
    : totalAmt;

  const anyPayerFunded  = payerParticipants.some((p) => p.isFunded === "YES");
  const myPayerIsFunded = payerParticipants.some(
    (p) => (p.email || "").toLowerCase() === myEmail && p.isFunded === "YES"
  );
  // null while loading (before API returns), then true/false
  const isCreator  = contractCreatedBy != null ? myMerchantId === contractCreatedBy : null;
  const isEditable = isCreator === true && contractStatus === "CREATED";

  const add = () => setPayers((p) => [...p, { participantId: null, name: "", email: "", wallet: "", contribution: "" }]);

  const rm = async (i) => {
    const payer = payers[i];
    // No existing participant — just remove from UI
    if (!payer?.participantId) {
      setPayers((p) => p.filter((_, idx) => idx !== i));
      return;
    }
    // Existing participant — call delete API first
    try {
      const res = await fetch(
        `${WEBSERVICE}/escrow/delete-escrow-participant?participantId=${payer.participantId}&contractId=${contractNumericId}&userId=${myMerchantId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      );
      const data = await res.json();
      if (data.status === true) {
        showToast("success", data.message || "Participant removed successfully.");
        setRefreshKey((k) => k + 1);
      } else {
        showToast("error", data.message || "Failed to remove participant.");
      }
    } catch {
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const upd = (i, key, val) => setPayers((p) => p.map((item, idx) => (idx === i ? { ...item, [key]: val } : item)));

  // ── Effects ──────────────────────────────────────────────────



  // Page load: fetch contract details
  useEffect(() => {
    if (!contractId) return;
    const merchantId = parseInt(localStorage.getItem(SITENAMEALIAS + "_merchant_id"), 10);
    fetchEscrowContractDetails(contractId, merchantId)
      .then((data) => {
        if (data.status === false) {
          showToast("error", data.message || "Failed to load contract details.");
          return;
        }
        const contract = Array.isArray(data.data) && data.data[0];
        if (!contract) return;
        setContractCreatedBy(contract.createdBy);
        setContractStatus(contract.status);
        if (contract.contractId) setContractNumericId(contract.contractId);
        if (contract.fundedCurrency) setContractCurrency(contract.fundedCurrency);
        const payerList = (contract.participants || []).filter((p) => p.role === "PAYER");
        setPayerParticipants(payerList);
        const displayAmount = contract.fundedAmount > 0
          ? contract.fundedAmount
          : contract.totalContractAmount;
        if (displayAmount > 0) {
          setFundTotalAmount(String(displayAmount));
        }
        // Pre-fill logged-in user's contribution % and load remaining co-payers
        const myEmailNow = (localStorage.getItem(SITENAMEALIAS + "_email") || "").toLowerCase();
        const mePayer    = payerList.find((p) => (p.email || "").toLowerCase() === myEmailNow);
        if (mePayer) {
          const myPct = mePayer.sharePercent ?? mePayer.contributionPercentage;
          if (myPct != null) setYouContribution(String(myPct));
          if (mePayer.participantId) setMyParticipantId(mePayer.participantId);
        }
        const coPayers = payerList
          .filter((p) => (p.email || "").toLowerCase() !== myEmailNow)
          .map((p) => ({
            participantId: p.participantId || null,
            name:          p.name          || "",
            email:         p.email         || "",
            wallet:        p.walletAddress  || "",
            contribution:  p.sharePercent != null ? String(p.sharePercent) : (p.contributionPercentage != null ? String(p.contributionPercentage) : ""),
            isFunded:      p.isFunded      || null,
          }));
        if (coPayers.length > 0) {
          setPayers(coPayers);
        }
      })
      .catch(() => {
        showToast("error", "Failed to load contract details.");
      });
  }, [contractId, refreshKey]);

  useEffect(() => {
    if (fundMethod !== "address") {
      setSelectedCrypto("");
      setSelectedNetwork("");
      setCryptoConvertedAmt(null);
    }
  }, [fundMethod]);

  useEffect(() => { setSelectedNetwork(""); }, [selectedCrypto]);

  // Fetch crypto list (currency_type === 2) for the crypto payment modal
  useEffect(() => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    setCryptoListLoading(true);
    FetchUsdBtcLedgerAmount({ merchant_id: merchantId })
      .then((res) => {
        const allCoins = res.data?.[0]?.coin_balance || [];
        const list = allCoins.filter(
          (c) => c.currency_type === "2" || c.currency_type === 2
        );
        setCryptoList(list);
        const fiatCoin = allCoins.find(
          (c) => (c.currency_code || "").toUpperCase() === homeCurrency.toUpperCase()
        );
        if (fiatCoin?.currency_id) setHomeCurrencyId(fiatCoin.currency_id);
      })
      .catch(() => {})
      .finally(() => setCryptoListLoading(false));
  }, []);

  useEffect(() => {
    if (!selectedCrypto) { setCryptoConvertedAmt(null); return; }
    setCryptoPriceLoading(true);
    fetch(`${WEBSERVICE}/merchant/getMarketPriceWithBaseCurrency?currency=${selectedCrypto}&baseCurrency=${contractCurrency}`)
      .then((r) => r.json())
      .then((res) => {
        if (res.error !== "0" && res.error !== 0) return;
        const price = parseFloat(res.price);
        const payerAmt = payerBase;
        if (price > 0 && payerAmt > 0) setCryptoConvertedAmt((payerAmt / price).toFixed(8));
      })
      .catch(() => {})
      .finally(() => setCryptoPriceLoading(false));
  }, [selectedCrypto, totalAmt, youAmt, youPct, payerParticipants]);

  // Fetch exchange rate to determine minimum fund amount (equivalent to 100 USD)
  useEffect(() => {
    if (!contractCurrency || contractCurrency.toUpperCase() === "USD") {
      setMinFundAmount(MIN_FUND_USD);
      return;
    }
    setMinAmountLoading(true);
    fetch(`${WEBSERVICE}/merchant/getMarketPriceWithBaseCurrency?currency=${contractCurrency}&baseCurrency=USD`)
      .then((r) => r.json())
      .then((res) => {
        if ((res.error === "0" || res.error === 0) && parseFloat(res.price) > 0) {
          const rate = parseFloat(res.price); // 1 USD = rate units of contractCurrency
          setMinFundAmount(Math.round(MIN_FUND_USD * rate * 100) / 100);
        } else {
          setMinFundAmount(MIN_FUND_USD);
        }
      })
      .catch(() => setMinFundAmount(MIN_FUND_USD))
      .finally(() => setMinAmountLoading(false));
  }, [contractCurrency]);

  // ── Fee calculation on payment method selection ─────────────
  useEffect(() => {
    const base = payerBase;
    if (!fundMethod || !base || base <= 0) {
      setFeeData(null);
      setFeeError(null);
      return;
    }
    const PM_MAP = { paypal: "PAYPAL", bank: "BANK_TRANSFER", address: "BY_RECEIVING_ADDRESS" };
    setFeeLoading(true);
    setFeeData(null);
    setFeeError(null);
    fetch(`${WEBSERVICE}/escrow/calculateFee`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      body: JSON.stringify({
        amount: base,
        contractAmount: totalAmt,
        currency: contractCurrency,
        paymentMethod: PM_MAP[fundMethod] || fundMethod.toUpperCase(),
      }),
    })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        if (data.status && data.data) {
          setFeeData(data.data);
        } else {
          setFeeError(data.message || "Fee calculation failed. Please try again.");
          setFundMethod("");
        }
      })
      .catch(() => {
        setFeeError("Unable to calculate fees. Please try again.");
        setFundMethod("");
      })
      .finally(() => setFeeLoading(false));
  }, [fundMethod, youAmt, totalAmt, youPct, payerParticipants]);

  // ── Crypto address payment polling ──────────────────────────
  useEffect(() => {
    if (!showAddressModal) {
      clearInterval(addrCountdownRef.current);
      return;
    }

    setAddrPaymentStatus(null);
    setAddrCountdown(15);
    let countdown = 15;

    const doCheck = () => {
      if (!contractNumericId) return;
      fetch(
        `${WEBSERVICE}/escrow/status?paymentMode=BY_RECEIVING_ADDRESS&contractId=${contractNumericId}`,
        { headers: { Authorization: "bearer " + getAuthToken(), UUID: getAuthUuid() } }
      )
        .then((r) => r.json())
        .then((data) => {
          if (data.paymentStatus === "SUCCESS") {
            setAddrPaymentStatus("SUCCESS");
            clearInterval(addrCountdownRef.current);
          }
        })
        .catch(() => {});
    };

    const tick = () => {
      countdown -= 1;
      if (countdown <= 0) {
        doCheck();
        countdown = 15;
      }
      setAddrCountdown(countdown);
    };

    addrCountdownRef.current = setInterval(tick, 1000);
    return () => clearInterval(addrCountdownRef.current);
  }, [showAddressModal, contractNumericId]);

  // ── Validation ───────────────────────────────────────────────
  const validate = () => {
    const e = {};

    if (contractStatus === "PARTIALLY_FUNDED") {
      if (!fundMethod) e.fundMethod = "Please select a payment method";
    } else {
      if (empty(fundTotalAmount) || isNaN(parseFloat(fundTotalAmount)) || parseFloat(fundTotalAmount) <= 0)
        e.fundTotalAmount = "Valid escrow amount is required";
      else if (parseFloat(fundTotalAmount) < minFundAmount)
        e.fundTotalAmount = `Minimum escrow amount is ${fmtMoney(minFundAmount, contractCurrency)} (equivalent to ${fmtMoney(MIN_FUND_USD, "USD")})`;

      // Validate "your" contribution
      if (youPct < 0 || youPct > 100)
        e.youContribution = "Your contribution must be between 0% and 100%";

      // Validate each co-payer
      payers.forEach((p, i) => {
        if (empty(p.name))  e[`payer_${i}_name`]  = "Name is required";
        if (empty(p.email)) e[`payer_${i}_email`] = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email)) e[`payer_${i}_email`] = "Invalid email";
        const pct = parseFloat(p.contribution) || 0;
        if (empty(p.contribution) || isNaN(pct) || pct <= 0)
          e[`payer_${i}_contribution`] = "Valid percentage required";
        else if (pct > 100)
          e[`payer_${i}_contribution`] = "Cannot exceed 100%";
      });

      // Validate combined total — must be exactly 100%
      const grandTotal = youPct + coPayerTotal;
      if (grandTotal > 100) {
        const over = (grandTotal - 100).toFixed(2).replace(/\.00$/, "");
        e.totalContribution = `Combined contributions are ${grandTotal % 1 === 0 ? grandTotal : grandTotal.toFixed(2)}% — ${over}% over the 100% limit. Reduce one or more contributions.`;
      } else if (grandTotal < 100) {
        const under = (100 - grandTotal).toFixed(2).replace(/\.00$/, "");
        e.totalContribution = `Combined contributions are ${grandTotal % 1 === 0 ? grandTotal : grandTotal.toFixed(2)}% — ${under}% short of the 100% required. Increase one or more contributions.`;
      }

      if (!fundMethod) e.fundMethod = "Please select a payment method";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // ── Shared API call for both Save Draft and Fund Escrow ─────────
  const callInsertFunding = async () => {
    const myName = [
      localStorage.getItem(SITENAMEALIAS + "_first_name") || "",
      localStorage.getItem(SITENAMEALIAS + "_last_name") || "",
    ].join(" ").trim();
    const myEmail = localStorage.getItem(SITENAMEALIAS + "_email") || "";

    const newPayerFundingDetails = [];
    const updatedPayerFundingDetails = [];

    // Logged-in user (you)
    const effectivePct = youPct > 0 ? youPct : (myParticipantPct > 0 ? myParticipantPct : inferredPct);
    if (effectivePct > 0) {
      const meEntry = {
        name:                   myName,
        email:                  myEmail,
        contributionPercentage: String(effectivePct),
        fundedCurrency:         contractCurrency,
      };
      if (myParticipantId) {
        updatedPayerFundingDetails.push({ participantId: myParticipantId, ...meEntry });
      } else {
        newPayerFundingDetails.push(meEntry);
      }
    }

    // Co-payers
    payers.forEach((p) => {
      const entry = {
        name:                   p.name,
        email:                  p.email,
        contributionPercentage: String(p.contribution),
        fundedCurrency:         contractCurrency,
      };
      if (p.participantId) {
        updatedPayerFundingDetails.push({ participantId: p.participantId, ...entry });
      } else {
        newPayerFundingDetails.push(entry);
      }
    });

    const response = await fetch(`${WEBSERVICE}/escrow/insert-funding`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      body: JSON.stringify({
        contractNo:                  contractId,
        totalAmount:                 parseFloat(fundTotalAmount) || 0,
        newPayerFundingDetails,
        updatedPayerFundingDetails,
      }),
    });
    return response.json();
  };

  const PAYMENT_MODE_MAP = {
    paypal:  "PAYPAL",
    bank:    "BANK_TRANSFER",
    address: "BY_RECEIVING_ADDRESS",
  };

  const callInsertPaymentFundEscrow = async () => {
    const payAmount = payerBase;
    await fetch(`${WEBSERVICE}/escrow/insert-payment-fund-escrow`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      body: JSON.stringify({
        merchantId:  myMerchantId,
        paymentMode: PAYMENT_MODE_MAP[fundMethod] || fundMethod.toUpperCase(),
        amount:      payAmount,
        contractId:  contractNumericId,
      }),
    });
    // fire-and-forget — proceed regardless of response
  };

  const handleFund = () => {
    if (!validate()) return;
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    setApiLoading(true);
    try {
      // Always call insert-funding first for every payment method
      const data = await callInsertFunding();
      if (data.status === false) {
        showToast("error", data.message || "Failed to fund escrow.");
        return;
      }

      // Record payment mode after insert-funding succeeds
      await callInsertPaymentFundEscrow();

      // Crypto: open crypto modal after funding is recorded
      if (fundMethod === "address") {
        setShowCryptoModal(true);
        return;
      }

      // PayPal: open modal directly — client ID is hardcoded, no API needed
      if (fundMethod === "paypal") {
        setShowPaypalModal(true);
        return;
      }

      // Bank: fetch fresh bank details then open modal
      if (fundMethod === "bank") {
        setBankDetailsLoading(true);
        try {
          const res = await fetch(`${WEBSERVICE}/escrow/merchant-payment-bank-details?currency=${contractCurrency}`, {
            headers: {
              Authorization: "bearer " + getAuthToken(),
              UUID: getAuthUuid(),
            },
          });
          const detailsRes = await res.json();
          if (detailsRes.status === true && detailsRes.data) {
            const { bankDetails: bd } = detailsRes.data;
            if (bd?.length > 0) setBankDetails(bd);
          }
        } catch {
          // use previously cached details if fetch fails
        } finally {
          setBankDetailsLoading(false);
        }
        setShowBankModal(true);
        return;
      }

      setSubmitted(true);
    } catch {
      showToast("error", "Network error. Please try again.");
    } finally {
      setApiLoading(false);
    }
  };

  const handlePayPalApprove = async (paypalData, captureResult) => {
    setShowPaypalModal(false);
    const pgTxnNumber = captureResult?.id || captureResult?.purchase_units?.[0]?.payments?.captures?.[0]?.id || paypalData?.orderID || "";
    const payAmount   = payerBase;
    setApiLoading(true);
    try {
      const res = await fetch(`${WEBSERVICE}/escrow/update-payment-fund-escrow`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify({
          merchantId:    myMerchantId,
          paymentMode:   "PAYPAL",
          amount:        payAmount,
          contractId:    contractNumericId,
          pgTxnNumber:   pgTxnNumber,
          paymentStatus: "SUCCESS",
          currencyId: null, // not needed for PayPal
        }),
      });
      const data = await res.json();
      if (data.status === false) {
        showToast("error", data.message || "Failed to update PayPal payment.");
        return;
      }
      setSubmitted(true);
    } catch {
      showToast("error", "Network error. Please try again.");
    } finally {
      setApiLoading(false);
    }
  };

  const handleCryptoSubmit = async () => {
    if (!selectedCrypto) {
      showToast("error", "Please select a cryptocurrency.");
      return;
    }
    if (needsNetwork && !selectedNetwork) {
      showToast("error", `Please select a network for ${selectedCrypto}.`);
      return;
    }
    setDepositAddressLoading(true);
    try {
      const coinObj = cryptoList.find((c) => c.currency_code === selectedCrypto);
      const currencyId = coinObj?.currency_id || 0;
      const payAmount = cryptoConvertedAmt
        ? parseFloat(cryptoConvertedAmt)
        : parseFloat(payerBase);

      const res = await fetch(
        "https://service.hashcashconsultants.com/billbitcoins-v2/escrow/crypto/address-generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
          body: JSON.stringify({
            contractId: contractNumericId,
            amount: payAmount,
            currencyId: currencyId,
            paymentMode: "ESCROW",
            merchantId: myMerchantId,
            network: needsNetwork ? selectedNetwork : "NATIVE",
          }),
        }
      );
      const data = await res.json();
      if (!data.status) {
        showToast("error", data.message || "Failed to generate receiving address.");
        return;
      }
      const addr = data?.data?.address || "";
      const memo = data?.data?.memo || "";
      setDepositAddress(String(addr));
      setDepositMemo(String(memo));
      setAddressCopied(false);
      setMemoCopied(false);
      setShowAddressModal(true);
    } catch {
      showToast("error", "Failed to fetch receiving address. Please try again.");
    } finally {
      setDepositAddressLoading(false);
    }
  };

  const handleSaveDraft = async () => {
    setApiLoading(true);
    try {
      const data = await callInsertFunding();
      if (data.status === false) {
        showToast("error", data.message || "Failed to save draft.");
      } else {
        showToast("success", "Funding saved as Draft");
      }
    } catch {
      showToast("error", "Network error. Please try again.");
    } finally {
      setApiLoading(false);
    }
  };

  // ── Success screen ───────────────────────────────────────────
  if (submitted) {
    return (
      <Fragment>
        <style>{CSS}</style>
        <div className="container-scroller">
          <Sidebar /><Header />
          <div className="main-panel">
            <div className="ecf-page ecf-view-in">
              <div className="ecf-success">
                <div className="ecf-success-icon">
                  <i className="fas fa-check" />
                </div>
                <p className="ecf-success-title">Escrow Funded Successfully</p>
                <p className="ecf-success-sub">
                  Contract <strong>#{contractId}</strong> has been funded. All parties will be notified. You can manage it from your contracts dashboard.
                </p>
                <button
                  className="ecf-btn-next"
                  style={{ marginTop: 8 }}
                  onClick={() => history.push("/escrow/payer/contracts")}
                >
                  <i className="fas fa-arrow-right" style={{ fontSize: 12 }} />
                  Go to Contracts
                </button>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </Fragment>
    );
  }

  // ── Shared view-only payers breakdown ─────────────────────────
  const fundedBadge = (p) => {
    if (p.isFunded === "YES")
      return { label: "Funded", style: { background: "rgba(16,185,129,.13)", color: "#10b981", border: "1px solid rgba(16,185,129,.28)" } };
    if (p.isFunded === "NO")
      return { label: "Pending", style: { background: "rgba(100,116,139,.13)", color: "#94a3b8", border: "1px solid rgba(100,116,139,.28)" } };
    return null;
  };

  const renderPayerBreakdown = (participants) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {participants.map((p, i) => {
        const pct    = p.sharePercent != null ? Number(p.sharePercent) : (p.contributionPercentage != null ? Number(p.contributionPercentage) : 0);
        const amt    = totalAmt * pct / 100;
        const isMe   = myEmail && (p.email || "").toLowerCase() === myEmail;
        const label  = isMe ? "You (Payer)" : (p.name || p.email || "—");
        const sub    = isMe ? p.email : (p.name ? p.email : null);
        const badge  = fundedBadge(p);
        return (
          <div key={p.participantId || i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: isMe ? "color-mix(in srgb, var(--btn-color) 5%, var(--body-color))" : "var(--body-color)", borderRadius: 8, border: `1px solid ${isMe ? "color-mix(in srgb, var(--btn-color) 25%, transparent)" : "var(--body-color-less2)"}` }}>
            <div style={{ flex: 1, fontSize: 13 }}>
              <span style={{ fontWeight: 600 }}>{label}</span>
              {sub && <span style={{ fontSize: 11, opacity: .5, marginLeft: 8 }}>{sub}</span>}
            </div>
            {badge && (
              <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 9px", borderRadius: 20, ...badge.style }}>
                {badge.label}
              </span>
            )}
            <span style={{ fontSize: 13, fontWeight: 600, color: "var(--btn-color)", minWidth: 48, textAlign: "right" }}>{pct}%</span>
            <span style={{ fontSize: 13, opacity: .4, margin: "0 4px" }}>→</span>
            <span style={{ fontSize: 14, fontWeight: 700, minWidth: 90, textAlign: "right" }}>{fmtAmt(amt)} {contractCurrency}</span>
          </div>
        );
      })}
      {/* Total row */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "var(--body-color-less)", borderRadius: 8, borderTop: "2px solid var(--body-color-less2)", marginTop: 2 }}>
        <div style={{ flex: 1, fontSize: 13, fontWeight: 700 }}>Total</div>
        <span style={{ fontSize: 13, opacity: .4, margin: "0 4px 0 auto" }}>→</span>
        <span style={{ fontSize: 16, fontWeight: 700, minWidth: 90, textAlign: "right", color: "var(--btn-color)" }}>
          {fmtAmt(totalAmt)} {contractCurrency}
        </span>
      </div>
    </div>
  );

  // ── Shared modals (confirm + payment method modals) ─────────────
  const modals = (
    <>
      {/* Confirm modal */}
      <div className={`ecf-confirm-bg${showConfirm ? " open" : ""}`}>
        <div className="ecf-confirm-box">
          <div className="ecf-confirm-icon">
            <i className="fas fa-wallet" />
          </div>
          <p className="ecf-confirm-title">Confirm &amp; Fund Escrow</p>
          <p className="ecf-confirm-msg">
            You are about to fund contract <strong>#{contractId}</strong>. Your payable amount is{" "}
            <strong>{fmtMoney(payerBase)}</strong>.{" "}
            {payers.length > 0
              ? `You and ${payers.length} payer${payers.length > 1 ? "s" : ""} will be charged their respective shares.`
              : "Your payment will be processed immediately."}{" "}
            All parties will be notified. This action cannot be undone.
          </p>
          <div className="ecf-confirm-terms">
            <input
              type="checkbox"
              id="ecf-terms-cb"
              checked={termsAccepted}
              onChange={e => setTermsAccepted(e.target.checked)}
            />
            <label htmlFor="ecf-terms-cb">
              I agree to the{" "}
              <a href="https://www.paybito.com/escrow/payer-terms" target="_blank" rel="noopener noreferrer">Payer Terms</a>,{" "}
              <a href="https://www.paybito.com/merchants-using-pay-services-terms-of-use/" target="_blank" rel="noopener noreferrer">Merchant Terms</a>,{" "}
              and{" "}
              <a href="https://www.paybito.com/exchange-fees/" target="_blank" rel="noopener noreferrer">Fee Schedule</a>.
            </label>
          </div>
          <div className="ecf-confirm-actions">
            <button className="ecf-confirm-cancel-btn" onClick={() => { setShowConfirm(false); setTermsAccepted(false); }}>Cancel</button>
            <button className="ecf-confirm-ok-btn" onClick={handleConfirm} disabled={!termsAccepted}>
              Confirm &amp; Submit
            </button>
          </div>
        </div>
      </div>

      {/* Crypto selection modal */}
      <div className={`ecf-crypto-bg${showCryptoModal ? " open" : ""}`}>
        <div className="ecf-crypto-modal-box">
          <div className="ecf-crypto-modal-header">
            <p className="ecf-crypto-modal-title">
              <i className="fas fa-coins" style={{ color: "#2563eb" }} />
              Pay with Crypto
            </p>
            <button className="ecf-crypto-modal-close" onClick={() => setShowCryptoModal(false)} disabled={depositAddressLoading}>
              <i className="fas fa-times" />
            </button>
          </div>
          <div className="ecf-paypal-amount-row">
            <span className="ecf-paypal-amount-label">Payment Amount</span>
            <span className="ecf-paypal-amount-value">
              {fmtAmt(payerBase)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
            </span>
          </div>
          <div className="ecf-net-title" style={{ marginTop: 4, marginBottom: 8 }}>Select Cryptocurrency</div>
          {cryptoListLoading ? (
            <div style={{ textAlign: "center", padding: "28px 0", fontSize: 13, color: "var(--text-color)", opacity: .55 }}>
              <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }} />
              Loading currencies…
            </div>
          ) : (
            <div className="ecf-coin-list">
              {(cryptoList.length > 0 ? cryptoList : CRYPTO_MASTER_LIST).map((coin) => {
                const isSelected = selectedCrypto === coin.currency_code;
                return (
                  <div
                    key={coin.currency_code}
                    className={`ecf-coin-row${isSelected ? " selected" : ""}`}
                    onClick={() => setSelectedCrypto(isSelected ? "" : coin.currency_code)}
                  >
                    <img src={coin.logo} alt={coin.currency_code} className="ecf-coin-logo" onError={(e) => { e.target.style.display = "none"; }} />
                    <div className="ecf-coin-info">
                      <div className="ecf-coin-code">{coin.currency_code}</div>
                      <div className="ecf-coin-name">{coin.currency_name}</div>
                    </div>
                    <div className="ecf-coin-radio">
                      {isSelected && <i className="fas fa-check" style={{ fontSize: 7, color: "#fff" }} />}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {needsNetwork && selectedCrypto && (
            <div className="ecf-net-section">
              <div className="ecf-net-title">Select Network</div>
              <div className="ecf-net-opts">
                {(
                  (cryptoList.find((c) => c.currency_code === selectedCrypto) ||
                   CRYPTO_MASTER_LIST.find((c) => c.currency_code === selectedCrypto))
                    ?.network ?? []
                ).map((n) => ({ key: n, name: n === "ERC" ? "ERC-20" : "TRC-20", desc: n === "ERC" ? "Ethereum network" : "Tron network" })).map((net) => (
                  <label key={net.key} className="ecf-net-opt">
                    <input type="radio" name="cryptoModalNetwork" value={net.key} checked={selectedNetwork === net.key} onChange={() => setSelectedNetwork(net.key)} />
                    <div>
                      <div className="ecf-net-opt-name">{net.name}</div>
                      <div className="ecf-net-opt-desc">{net.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}
          {selectedCrypto && (!needsNetwork || selectedNetwork) && (
            <div className="ecf-crypto-equiv-box">
              <span className="ecf-crypto-equiv-label">
                Equivalent in {selectedCrypto}{selectedNetwork ? ` (${selectedNetwork === "ERC" ? "ERC-20" : "TRC-20"})` : ""}
              </span>
              {cryptoPriceLoading ? (
                <span className="ecf-crypto-spinner" />
              ) : cryptoConvertedAmt ? (
                <span className="ecf-crypto-equiv-val">{cryptoConvertedAmt} {selectedCrypto}</span>
              ) : (
                <span style={{ fontSize: 13, color: "var(--text-color)", opacity: .4 }}>—</span>
              )}
            </div>
          )}
          <button
            className="ecf-crypto-proceed-btn"
            onClick={handleCryptoSubmit}
            disabled={depositAddressLoading || !selectedCrypto || (needsNetwork && !selectedNetwork)}
          >
            {depositAddressLoading ? (
              <><i className="fas fa-spinner fa-spin" style={{ fontSize: 13 }} /> Fetching Address…</>
            ) : (
              <><i className="fas fa-wallet" style={{ fontSize: 13 }} /> Get Receiving Address</>
            )}
          </button>
        </div>
      </div>

      {/* Bank Transfer popup modal */}
      <div className={`ecf-bank-bg${showBankModal ? " open" : ""}`}>
        <div className="ecf-bank-box">
          <div className="ecf-bank-modal-header">
            <p className="ecf-bank-modal-title">
              <i className="fas fa-university" style={{ color: "#e03535" }} />
              Bank Transfer Details
            </p>
            <button className="ecf-bank-modal-close" onClick={() => { setShowBankModal(false); history.push("/escrow/payer/contracts"); }}>
              <i className="fas fa-times" />
            </button>
          </div>
          {(() => {
            const base = payerBase;
            const total = base + (feeData?.calculatedFee || 0);
            return (
              <>
                <div className="ecf-paypal-amount-row" style={{ marginBottom: feeData ? 10 : 18 }}>
                  <span className="ecf-paypal-amount-label">Amount to Transfer</span>
                  <span className="ecf-paypal-amount-value">
                    {fmtAmt(total)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
                  </span>
                </div>
                {feeData && (
                  <div className="ecf-fee-box" style={{ marginBottom: 18 }}>
                    <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                    <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                  </div>
                )}
              </>
            );
          })()}
          <div className="ecf-bank-notice">
            <p className="ecf-bank-notice-title">
              <i className="fas fa-info-circle" style={{ fontSize: 12 }} />
              This is the amount in {contractCurrency} you must transfer.
            </p>
            <ul className="ecf-bank-notice-list">
              <li>The amount displayed here must reach us in full to avoid delays in processing.</li>
              <li>Bank charges or platform rate adjustment must be made at your end.</li>
              <li>Your Escrow contract will be funded as soon as the transfer reaches us.</li>
            </ul>
          </div>
          <p className="ecf-bank-details-title" style={{ marginTop: 14 }}>
            <i className="fas fa-university" style={{ fontSize: 11 }} />
            Make the transfer to the bank given below.
          </p>
          {bankDetailsLoading ? (
            <div style={{ textAlign: "center", padding: "24px 0", fontSize: 13, color: "var(--text-color)", opacity: .55 }}>
              <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }} />
              Loading bank details…
            </div>
          ) : bankDetails?.length > 0 ? (
            bankDetails.map((bd, idx) => (
              <div key={bd.bankId || idx}>
                {bankDetails.length > 1 && (
                  <p style={{ fontWeight: 600, fontSize: 13, margin: idx === 0 ? "0 0 6px" : "16px 0 6px" }}>
                    Bank {idx + 1}: {bd.bankName}
                  </p>
                )}
                <table className="ecf-bank-table">
                  <tbody>
                    {(bd.beneficiaryName || bd.benificiaryName) && (<tr><td>Beneficiary Name</td><td>{bd.beneficiaryName || bd.benificiaryName}</td></tr>)}
                    {bd.beneficiaryAddress && (<tr><td>Beneficiary Address</td><td>{bd.beneficiaryAddress}</td></tr>)}
                    {bd.bankName && (<tr><td>Bank Name</td><td>{bd.bankName}</td></tr>)}
                    {bd.bankAddress && (<tr><td>Bank Address</td><td>{bd.bankAddress}</td></tr>)}
                    {bd.accountNo && (<tr><td>Account No</td><td>{bd.accountNo}</td></tr>)}
                    {bd.accountType && (<tr><td>Account Type</td><td>{bd.accountType}</td></tr>)}
                    {bd.routingNo && (<tr><td>Routing No</td><td>{bd.routingNo}</td></tr>)}
                    {bd.swiftCode && (<tr><td>Swift Code</td><td>{bd.swiftCode}</td></tr>)}
                    {bd.ifscCode && (<tr><td>IFSC Code</td><td>{bd.ifscCode}</td></tr>)}
                    {bd.intermediaryBankName && (<tr><td>Intermediary Bank Name</td><td>{bd.intermediaryBankName}</td></tr>)}
                    {bd.intermediaryBankSwiftCode && (<tr><td>Intermediary Bank Swift Code</td><td>{bd.intermediaryBankSwiftCode}</td></tr>)}
                    {bd.note && (
                      <tr>
                        <td>Note</td>
                        <td>
                          {/<[a-z][\s\S]*>/i.test(bd.note)
                            ? <span dangerouslySetInnerHTML={{ __html: bd.note }} />
                            : bd.note}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "var(--text-color)", opacity: .45 }}>
              <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />
              Bank details not available.
            </div>
          )}
          <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
            <button className="ecf-confirm-cancel-btn" onClick={() => { setShowBankModal(false); history.push("/escrow/payer/contracts"); }}>
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Deposit Address modal */}
      {(() => {
        const coinObj =
          cryptoList.find((c) => c.currency_code === selectedCrypto) ||
          CRYPTO_MASTER_LIST.find((c) => c.currency_code === selectedCrypto);
        const networkLabel =
          selectedNetwork === "ERC" ? "ERC-20" :
          selectedNetwork === "TRC" ? "TRC-20" : null;
        const qrUrl = depositAddress
          ? `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(depositAddress)}`
          : null;
        return (
          <div className={`ecf-addr-bg${showAddressModal ? " open" : ""}`}>
            <div className="ecf-addr-box">
              <div className="ecf-addr-header">
                <p className="ecf-addr-title">
                  <i className="fas fa-wallet" style={{ color: "#2563eb" }} />
                  Deposit Address
                </p>
                <button className="ecf-addr-close" onClick={() => setShowAddressModal(false)}>
                  <i className="fas fa-times" />
                </button>
              </div>
              {addrPaymentStatus === "SUCCESS" ? (
                <div className="ecf-addr-success">
                  <div className="ecf-addr-success-icon"><i className="fas fa-check" /></div>
                  <p className="ecf-addr-success-title">Payment Successfully Received!</p>
                  <p className="ecf-addr-success-sub">
                    Your crypto payment has been confirmed on the blockchain.
                    The escrow contract will now be activated.
                  </p>
                  <button className="ecf-addr-success-btn" onClick={() => { setShowAddressModal(false); setShowCryptoModal(false); setSubmitted(true); }}>
                    <i className="fas fa-check" style={{ fontSize: 13 }} />
                    Payment has been received
                  </button>
                </div>
              ) : (
              <>
              {coinObj && (
                <div className="ecf-addr-coin-row">
                  <img src={coinObj.logo} alt={coinObj.currency_code} className="ecf-addr-coin-logo" onError={(e) => { e.target.style.display = "none"; }} />
                  <div>
                    <div className="ecf-addr-coin-name">
                      {coinObj.currency_name}
                      {networkLabel && <span className="ecf-addr-coin-network">{networkLabel}</span>}
                    </div>
                    <div style={{ fontSize: 11, color: "var(--text-color)", opacity: .5, marginTop: 2 }}>{coinObj.currency_code}</div>
                  </div>
                </div>
              )}
              {(() => {
                const base = payerBase;
                const total = base + (feeData?.calculatedFee || 0);
                return (
                  <>
                    <div className="ecf-addr-amt-row" style={{ marginBottom: feeData ? 10 : 18 }}>
                      <span className="ecf-addr-amt-label">Amount to Send</span>
                      <span className="ecf-addr-amt-val">
                        {cryptoConvertedAmt ? `${cryptoConvertedAmt} ${selectedCrypto}` : `${fmtAmt(total)} ${contractCurrency}`}
                      </span>
                    </div>
                    {feeData && !cryptoConvertedAmt && (
                      <div className="ecf-fee-box" style={{ marginBottom: 18 }}>
                        <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                        <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row ecf-fee-total"><span>Total to Send</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                      </div>
                    )}
                  </>
                );
              })()}
              {qrUrl && (
                <div className="ecf-addr-qr-wrap">
                  <img src={qrUrl} alt="Deposit QR Code" className="ecf-addr-qr" />
                </div>
              )}
              <div className="ecf-addr-field-label">Receiving Address</div>
              {depositAddress ? (
                <div className={`ecf-addr-copy-row${addressCopied ? " copied" : ""}`}>
                  <span className="ecf-addr-text">{depositAddress}</span>
                  <button
                    className={`ecf-addr-copy-btn${addressCopied ? " copied" : ""}`}
                    onClick={() => { navigator.clipboard.writeText(depositAddress).then(() => { setAddressCopied(true); setTimeout(() => setAddressCopied(false), 2500); }); }}
                  >
                    <i className={`fas ${addressCopied ? "fa-check" : "fa-copy"}`} style={{ fontSize: 11 }} />
                    {addressCopied ? "Copied!" : "Copy"}
                  </button>
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "18px 0", fontSize: 13, color: "var(--text-color)", opacity: .45 }}>
                  <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />
                  Address not available. Please contact support.
                </div>
              )}
              {(selectedCrypto === "XRP" || selectedCrypto === "HCX") && depositMemo && (
                <>
                  <div className="ecf-addr-field-label" style={{ marginTop: 14 }}>Memo / Destination Tag</div>
                  <div className={`ecf-addr-copy-row${memoCopied ? " copied" : ""}`}>
                    <span className="ecf-addr-text">{depositMemo}</span>
                    <button
                      className={`ecf-addr-copy-btn${memoCopied ? " copied" : ""}`}
                      onClick={() => { navigator.clipboard.writeText(depositMemo).then(() => { setMemoCopied(true); setTimeout(() => setMemoCopied(false), 2500); }); }}
                    >
                      <i className={`fas ${memoCopied ? "fa-check" : "fa-copy"}`} style={{ fontSize: 11 }} />
                      {memoCopied ? "Copied!" : "Copy"}
                    </button>
                  </div>
                  <div style={{ marginTop: 8, padding: "8px 12px", background: "rgba(239,68,68,.07)", border: "1px solid rgba(239,68,68,.2)", borderRadius: 8, fontSize: 12, color: "#ef4444", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fas fa-exclamation-circle" style={{ flexShrink: 0, marginTop: 0 }} />
                    <span>You <strong>must</strong> include this memo when sending. Transactions without the correct memo may be lost.</span>
                  </div>
                </>
              )}
              <div className="ecf-addr-notice">
                <i className="fas fa-exclamation-triangle" style={{ color: "#f59e0b", flexShrink: 0, marginTop: 1 }} />
                <span>
                  Send only <strong>{selectedCrypto}</strong>{networkLabel ? ` (${networkLabel})` : ""} to this address.
                  Sending any other asset may result in <strong>permanent loss of funds</strong>.
                </span>
              </div>
              <div className="ecf-addr-countdown">
                <span className="ecf-addr-countdown-text">
                  <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 11 }} />
                  Checking payment status in
                </span>
                <span className="ecf-addr-countdown-num">{addrCountdown}s</span>
              </div>
              </>
              )}
            </div>
          </div>
        );
      })()}

      {/* PayPal popup modal */}
      <div className={`ecf-paypal-bg${showPaypalModal ? " open" : ""}`}>
        <div className="ecf-paypal-box">
          <div className="ecf-paypal-header">
            <p className="ecf-paypal-title">
              <img src="https://www.paypalobjects.com/webstatic/icon/pp258.png" alt="PayPal" style={{ width: 22, height: 22, objectFit: "contain" }} />
              Pay with PayPal
            </p>
            <button className="ecf-paypal-close" onClick={() => setShowPaypalModal(false)}>
              <i className="fas fa-times" />
            </button>
          </div>
          {(() => {
            const base = payerBase;
            const total = base + (feeData?.calculatedFee || 0);
            return (
              <>
                <div className="ecf-paypal-amount-row" style={{ marginBottom: feeData ? 10 : 20 }}>
                  <span className="ecf-paypal-amount-label">Payment Amount</span>
                  <span className="ecf-paypal-amount-value">
                    {fmtAmt(total)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
                  </span>
                </div>
                {feeData && (
                  <div className="ecf-fee-box" style={{ marginBottom: 20 }}>
                    <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                    <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                  </div>
                )}
              </>
            );
          })()}
          {showPaypalModal && totalAmt > 0 && (
            <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, currency: contractCurrency }}>
              <PayPalButtons
                style={{ layout: "vertical", color: "blue", shape: "rect", label: "pay", height: 45 }}
                createOrder={(_data, actions) =>
                  actions.order.create({
                    purchase_units: [{
                      amount: {
                        value: ((payerBase) + (feeData?.calculatedFee || 0)).toFixed(2),
                        currency_code: contractCurrency,
                      },
                      description: `Escrow Contract #${contractId}`,
                    }],
                  })
                }
                onApprove={(_data, actions) =>
                  actions.order.capture().then((captureResult) => handlePayPalApprove(_data, captureResult))
                }
                onError={() => showToast("error", "PayPal payment failed. Please try again.")}
                onCancel={() => setShowPaypalModal(false)}
              />
            </PayPalScriptProvider>
          )}
        </div>
      </div>
    </>
  );

  // ── Non-creator view (co-payer): only total + breakdown ────────
  if (isCreator === false) {
    return (
      <Fragment>
        <style>{CSS}</style>
        <div className="container-scroller">
          <Sidebar /><Header />
          <div className="main-panel">
            <div className="ecf-page ecf-view-in">

              <button className="ecf-back-link" onClick={() => history.goBack()}>
                <span className="ecf-back-arrow"><i className="fas fa-arrow-left" /></span>
                Back
              </button>

              <div className="ecf-hdr">
                <h1 className="ecf-title">Fund Escrow Contract</h1>
                <p className="ecf-sub">Enter payment details and fund the escrow to activate this contract.</p>
                <div className="ecf-contract-badge">
                  <i className="fas fa-file-contract" style={{ fontSize: 11 }} />
                  Contract ID: {contractId}
                </div>
              </div>

              {/* Section 1: Total Escrow Amount — read-only for non-creator */}
              <div className="ecf-section">
                <div className="ecf-section-hdr">
                  <p className="ecf-section-title">
                    <i className="fas fa-lock" style={{ fontSize: 11 }} /> Total Escrow Amount
                  </p>
                </div>
                <div style={{ fontSize: 28, fontWeight: 700, color: "var(--btn-color)", marginBottom: 4 }}>
                  {fmtAmt(totalAmt)} <span style={{ fontSize: 14, fontWeight: 600, opacity: .6 }}>{contractCurrency}</span>
                </div>
              </div>

              {/* Section 3: Payment Breakdown */}
              {totalAmt > 0 && (
                <div className="ecf-section">
                  <div className="ecf-section-hdr">
                    <p className="ecf-section-title">
                      <i className="fas fa-chart-pie" style={{ fontSize: 11 }} /> Payment Breakdown
                    </p>
                  </div>
                  {renderPayerBreakdown(payerParticipants)}
                </div>
              )}

              {/* Section 4: Your Payment — hidden when logged-in payer has already funded */}
              {totalAmt > 0 && !myPayerIsFunded && (
                <div className="ecf-section">
                  <div className="ecf-section-hdr">
                    <p className="ecf-section-title">
                      <i className="fas fa-credit-card" style={{ fontSize: 11 }} /> Your Payment
                    </p>
                  </div>
                  <div className="ecf-fund-grid">
                    {FUND_METHODS.map((m) => (
                      <label key={m.key} className={`ecf-fund-card${fundMethod === m.key ? " selected" : ""}`} style={{ "--ecf-fund-color": m.color }} onClick={() => setFundMethod(m.key)}>
                        <input type="radio" name="fundMethod" value={m.key} checked={fundMethod === m.key} onChange={() => setFundMethod(m.key)} />
                        <div className="ecf-fund-card-check">{fundMethod === m.key && <i className="fas fa-check" />}</div>
                        <div className="ecf-fund-card-icon">{m.logo ? <img src={m.logo} alt={m.title} style={{ width: 32, height: 32, objectFit: "contain" }} /> : <i className={m.icon} />}</div>
                        <div className="ecf-fund-card-title">{m.title}</div>
                        <div className="ecf-fund-card-desc">{m.desc}</div>
                      </label>
                    ))}
                  </div>
                  {errors.fundMethod && (
                    <span className="ecf-err" style={{ marginTop: 12, display: "block" }}>{errors.fundMethod}</span>
                  )}

                  {/* Fee breakdown */}
                  {feeLoading && (
                    <div className="ecf-fee-loader">
                      <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 11 }} />
                      Calculating fees…
                    </div>
                  )}
                  {feeError && !feeLoading && (
                    <div style={{ marginTop: 12, padding: "10px 13px", background: "rgba(239,68,68,.07)", border: "1px solid rgba(239,68,68,.22)", borderRadius: 9, fontSize: 12, color: "#ef4444", display: "flex", alignItems: "center", gap: 8 }}>
                      <i className="fas fa-exclamation-circle" style={{ flexShrink: 0 }} />
                      {feeError}
                    </div>
                  )}
                  {feeData && !feeLoading && (() => {
                    const base = payerBase;
                    return (
                      <div className="ecf-fee-box">
                        <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                        <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(base + feeData.calculatedFee)} {contractCurrency}</span></div>
                      </div>
                    );
                  })()}
                </div>
              )}

              {/* Footer — non-creator can only Fund Escrow, no Save as Draft */}
              {!myPayerIsFunded && (
                <div className="ecf-footer">
                  <button className="ecf-btn-fund" onClick={handleFund} disabled={apiLoading || feeLoading || (contractStatus !== "PARTIALLY_FUNDED" && (!!feeError || totalAmt <= 0 || (youPct + coPayerTotal) > 100))}>
                    <i className={`fas ${feeLoading ? "fa-circle-notch fa-spin" : "fa-wallet"}`} style={{ fontSize: 13 }} />
                    {feeLoading ? "Calculating fees…" : "Fund Escrow"}
                  </button>
                </div>
              )}

            </div>
            <Footer />
          </div>
        </div>
      {modals}
      </Fragment>
    );
  }

  // ── Creator view-only (status !== CREATED): all sections read-only
  if (isCreator === true && contractStatus !== "CREATED" && contractStatus != null) {
    return (
      <Fragment>
        <style>{CSS}</style>
        <div className="container-scroller">
          <Sidebar /><Header />
          <div className="main-panel">
            <div className="ecf-page ecf-view-in">

              <button className="ecf-back-link" onClick={() => history.goBack()}>
                <span className="ecf-back-arrow"><i className="fas fa-arrow-left" /></span>
                Back
              </button>

              <div className="ecf-hdr">
                <h1 className="ecf-title">Fund Escrow Contract</h1>
                <p className="ecf-sub">This contract has already been processed and is read-only.</p>
                <div className="ecf-contract-badge">
                  <i className="fas fa-file-contract" style={{ fontSize: 11 }} />
                  Contract ID: {contractId}
                </div>
              </div>

              {/* Total Escrow Amount — read-only */}
              <div className="ecf-section">
                <div className="ecf-section-hdr">
                  <p className="ecf-section-title">
                    <i className="fas fa-lock" style={{ fontSize: 11 }} /> Total Escrow Amount
                  </p>
                </div>
                <div style={{ fontSize: 28, fontWeight: 700, color: "var(--btn-color)", marginBottom: 4 }}>
                  {fmtAmt(totalAmt)} <span style={{ fontSize: 14, fontWeight: 600, opacity: .6 }}>{contractCurrency}</span>
                </div>
              </div>

              {/* Payers — read-only, hidden when funded */}
              {contractStatus !== "FUNDED" && payerParticipants.length > 0 && (
                <div className="ecf-section">
                  <div className="ecf-section-hdr">
                    <p className="ecf-section-title">
                      <i className="fas fa-users" style={{ fontSize: 11 }} /> Payers
                    </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {payerParticipants.map((p, i) => {
                      const isMe  = myEmail && (p.email || "").toLowerCase() === myEmail;
                      const label = isMe ? "You (Payer)" : (p.name || p.email || "—");
                      const sub   = isMe ? p.email : (p.name ? p.email : null);
                      const badge = fundedBadge(p);
                      return (
                        <div key={p.participantId || i} className="ecf-participant" style={{ marginBottom: 0, ...(isMe ? { background: "color-mix(in srgb, var(--btn-color) 5%, var(--body-color))", borderColor: "color-mix(in srgb, var(--btn-color) 25%, transparent)" } : {}) }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                            <div className="ecf-participant-num" style={isMe ? { color: "var(--btn-color)", opacity: 1 } : {}}>
                              {isMe ? <><i className="fas fa-user" style={{ fontSize: 10, marginRight: 5 }} />You</> : `Payer ${i + 1}`}
                            </div>
                            {badge && (
                              <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 9px", borderRadius: 20, ...badge.style }}>
                                {badge.label}
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-color)", marginBottom: 2 }}>{label}</div>
                          {sub && <div style={{ fontSize: 12, color: "var(--text-color)", opacity: .55 }}>{sub}</div>}
                          {p.sharePercent != null && (
                            <div style={{ marginTop: 8, fontSize: 13, color: "var(--btn-color)", fontWeight: 600 }}>
                              Contribution: {p.sharePercent}%
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Payment Breakdown — read-only, hidden when funded */}
              {contractStatus !== "FUNDED" && (
                <div className="ecf-section">
                  <div className="ecf-section-hdr">
                    <p className="ecf-section-title">
                      <i className="fas fa-chart-pie" style={{ fontSize: 11 }} /> Payment Breakdown
                    </p>
                  </div>
                  {renderPayerBreakdown(payerParticipants)}
                </div>
              )}

            </div>
            <Footer />
          </div>
        </div>
      </Fragment>
    );
  }

  // ── Main render (creator + status CREATED = editable) ────────
  return (
    <Fragment>
      <style>{CSS}</style>
      <div className="container-scroller">
        <Sidebar /><Header />
        <div className="main-panel">
          <div className="ecf-page ecf-view-in">

            {/* Back */}
            <button className="ecf-back-link" onClick={() => history.push("/escrow/payer/contracts")}>
              <span className="ecf-back-arrow"><i className="fas fa-arrow-left" /></span>
              Back to Contracts
            </button>

            {/* Header */}
            <div className="ecf-hdr">
              <h1 className="ecf-title">Fund Escrow Contract</h1>
              <p className="ecf-sub">Enter payment details and fund the escrow to activate this contract.</p>
              <div className="ecf-contract-badge">
                <i className="fas fa-file-contract" style={{ fontSize: 11 }} />
                Contract ID: {contractId}
              </div>
            </div>

            {/* ── Section 1: Total Escrow Amount ── */}
            <div className="ecf-section">
              <div className="ecf-section-hdr">
                <p className="ecf-section-title">
                  <i className="fas fa-lock" style={{ fontSize: 11 }} /> Total Escrow Amount
                </p>
              </div>
              <p style={{ fontSize: 13, color: "var(--text-color)", opacity: .6, margin: "0 0 18px", lineHeight: 1.55 }}>
                Enter the full amount that will be held in escrow for this contract.
              </p>
              <Field label={`Total Escrow Amount (${contractCurrency})`} req error={errors.fundTotalAmount}>
                <div style={{ position: "relative", maxWidth: 300 }}>
                  <input
                    className={`ecf-fund-amount-field${errors.fundTotalAmount ? " error" : ""}`}
                    type="number"
                    min="0"
                    placeholder="0.00"
                    value={fundTotalAmount}
                    onChange={(e) => setFundTotalAmount(e.target.value)}
                    disabled={anyPayerFunded}
                    style={anyPayerFunded ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                  />
                  <span className="ecf-fund-amount-currency">{contractCurrency}</span>
                </div>
                <p style={{ margin: "6px 0 0", fontSize: 12, color: "var(--text-color)", opacity: 0.55, lineHeight: 1.4 }}>
                  {minAmountLoading
                    ? "Fetching minimum amount..."
                    : `Minimum: ${fmtMoney(minFundAmount, contractCurrency)} (equivalent to ${fmtMoney(MIN_FUND_USD, "USD")})`}
                </p>
              </Field>
            </div>

            {/* ── Section 2: Payers ── */}
            {totalAmt > 0 && !anyPayerFunded && (
              <div className="ecf-section">
                <div className="ecf-section-hdr">
                  <p className="ecf-section-title">
                    <i className="fas fa-users" style={{ fontSize: 11 }} /> Payers
                    <span style={{ marginLeft: 8, fontWeight: 500, fontSize: 11, opacity: .55 }}>Optional</span>
                  </p>
                </div>
                <p style={{ fontSize: 13, color: "var(--text-color)", opacity: .6, margin: "0 0 18px", lineHeight: 1.55 }}>
                  Add all payers and assign each one a percentage of the total amount.
                </p>

                {/* You (Payer) — fixed card */}
                <div className="ecf-participant" style={{ background: "color-mix(in srgb, var(--btn-color) 5%, var(--body-color))", borderColor: "color-mix(in srgb, var(--btn-color) 25%, transparent)" }}>
                  <div className="ecf-participant-num" style={{ color: "var(--btn-color)", opacity: 1 }}>
                    <i className="fas fa-user" style={{ fontSize: 10, marginRight: 5 }} />You (Payer)
                  </div>
                  <div style={{ maxWidth: 200 }}>
                    <Field label="Your Contribution %" req>
                      <div className="ecf-pct-row">
                        <input
                          className={`ecf-input${errors.youContribution ? " error" : ""}`}
                          type="number"
                          min="0"
                          max="100"
                          placeholder="e.g. 100"
                          value={youContribution}
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === "") { setYouContribution(""); return; }
                            const n = parseFloat(raw);
                            if (!isNaN(n) && n > 100) { setYouContribution("100"); return; }
                            if (!isNaN(n) && n < 0)   { setYouContribution("0");   return; }
                            setYouContribution(raw);
                          }}
                        />
                        <span className="ecf-pct-suffix">%</span>
                      </div>
                    </Field>
                  </div>
                  {youPct > 0 && (
                    <div style={{ marginTop: 10, padding: "8px 12px", background: "color-mix(in srgb, var(--btn-color) 6%, transparent)", borderRadius: 8, fontSize: 13, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <span style={{ opacity: .65 }}>You will pay:</span>
                      <span style={{ fontWeight: 700, color: "var(--btn-color)" }}>{fmtAmt(youAmt)} {contractCurrency}</span>
                    </div>
                  )}
                </div>

                {/* Co-payer cards */}
                {payers.map((payer, i) => {
                  const payerAmt = totalAmt * (parseFloat(payer.contribution) || 0) / 100;
                  return (
                    <div className="ecf-participant" key={i}>
                      <div className="ecf-participant-num">Payer {i + 1}</div>
                      <button className="ecf-participant-rm" onClick={() => rm(i)}>
                        <i className="fas fa-times" />
                      </button>
                      <div className="ecf-grid-3">
                        <Field label="Full Name" req error={errors[`payer_${i}_name`]}>
                          <input
                            className={`ecf-input${errors[`payer_${i}_name`] ? " error" : ""}`}
                            placeholder="e.g. John Smith"
                            value={payer.name}
                            onChange={(e) => upd(i, "name", e.target.value)}
                          />
                        </Field>
                        <Field label="Email Address" req error={errors[`payer_${i}_email`]}>
                          <input
                            className={`ecf-input${errors[`payer_${i}_email`] ? " error" : ""}`}
                            placeholder="john@example.com"
                            value={payer.email}
                            onChange={(e) => upd(i, "email", e.target.value)}
                          />
                        </Field>
                        <Field label="Contribution %" req error={errors[`payer_${i}_contribution`]}>
                          <div className="ecf-pct-row">
                            <input
                              className={`ecf-input${errors[`payer_${i}_contribution`] ? " error" : ""}`}
                              type="number"
                              min="1"
                              max="100"
                              placeholder="e.g. 50"
                              value={payer.contribution}
                              onChange={(e) => {
                                const raw = e.target.value;
                                if (raw === "") { upd(i, "contribution", ""); return; }
                                const n = parseFloat(raw);
                                if (!isNaN(n) && n > 100) { upd(i, "contribution", "100"); return; }
                                if (!isNaN(n) && n < 0)   { upd(i, "contribution", "0");   return; }
                                upd(i, "contribution", raw);
                              }}
                            />
                            <span className="ecf-pct-suffix">%</span>
                          </div>
                        </Field>
                      </div>
                      {(parseFloat(payer.contribution) || 0) > 0 && (
                        <div style={{ marginTop: 10, padding: "8px 12px", background: "color-mix(in srgb, var(--btn-color) 6%, transparent)", borderRadius: 8, fontSize: 13, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <span style={{ opacity: .65 }}>They will pay:</span>
                          <span style={{ fontWeight: 700, color: "var(--btn-color)" }}>{fmtAmt(payerAmt)} {contractCurrency}</span>
                        </div>
                      )}
                    </div>
                  );
                })}

                <button className="ecf-btn-add" onClick={add} style={{ marginTop: 4 }}>
                  <i className="fas fa-plus" style={{ fontSize: 11 }} /> Add Another Payer
                </button>
              </div>
            )}

            {/* ── Section 3: Payment Breakdown ── */}
            {totalAmt > 0 && (
              <div className="ecf-section">
                <div className="ecf-section-hdr">
                  <p className="ecf-section-title">
                    <i className="fas fa-chart-pie" style={{ fontSize: 11 }} /> Payment Breakdown
                  </p>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {/* You (Payer) row */}
                  {youPct > 0 && (() => {
                    const mePayer = payerParticipants.find((p) => (p.email || "").toLowerCase() === myEmail);
                    const myBadge = mePayer ? fundedBadge(mePayer) : null;
                    return (
                      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "color-mix(in srgb, var(--btn-color) 5%, var(--body-color))", borderRadius: 8, border: "1px solid color-mix(in srgb, var(--btn-color) 25%, transparent)" }}>
                        <div style={{ flex: 1, fontSize: 13 }}>
                          <span style={{ fontWeight: 600 }}>You (Payer)</span>
                        </div>
                        {myBadge && (
                          <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 9px", borderRadius: 20, ...myBadge.style }}>
                            {myBadge.label}
                          </span>
                        )}
                        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--btn-color)", minWidth: 48, textAlign: "right" }}>{youPct}%</span>
                        <span style={{ fontSize: 13, opacity: .4, margin: "0 4px" }}>→</span>
                        <span style={{ fontSize: 14, fontWeight: 700, minWidth: 90, textAlign: "right" }}>{fmtAmt(youAmt)} {contractCurrency}</span>
                      </div>
                    );
                  })()}

                  {/* Co-payer rows */}
                  {payers.map((p, i) => {
                    const pct   = parseFloat(p.contribution) || 0;
                    const amt   = totalAmt * pct / 100;
                    const badge = fundedBadge(p);
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "var(--body-color)", borderRadius: 8, border: "1px solid var(--body-color-less2)" }}>
                        <div style={{ flex: 1, fontSize: 13 }}>
                          <span style={{ fontWeight: 600 }}>{p.name || `Payer ${i + 1}`}</span>
                          {p.email && <span style={{ fontSize: 11, opacity: .5, marginLeft: 8 }}>{p.email}</span>}
                        </div>
                        {badge && (
                          <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 9px", borderRadius: 20, ...badge.style }}>
                            {badge.label}
                          </span>
                        )}
                        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--btn-color)", minWidth: 48, textAlign: "right" }}>{pct}%</span>
                        <span style={{ fontSize: 13, opacity: .4, margin: "0 4px" }}>→</span>
                        <span style={{ fontSize: 14, fontWeight: 700, minWidth: 90, textAlign: "right" }}>{fmtAmt(amt)} {contractCurrency}</span>
                      </div>
                    );
                  })}

                  {/* Total row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "var(--body-color-less)", borderRadius: 8, borderTop: "2px solid var(--body-color-less2)", marginTop: 2 }}>
                    <div style={{ flex: 1, fontSize: 13, fontWeight: 700 }}>Total</div>
                    <span style={{ fontSize: 13, fontWeight: 700, minWidth: 48, textAlign: "right", color: (youPct + coPayerTotal) > 100 ? "#ef4444" : (youPct + coPayerTotal) === 100 ? "#10b981" : "var(--btn-color)" }}>
                      {fmtPct(youPct + coPayerTotal)}%
                    </span>
                    <span style={{ fontSize: 13, opacity: .4, margin: "0 4px" }}>→</span>
                    <span style={{ fontSize: 16, fontWeight: 700, minWidth: 90, textAlign: "right", color: "var(--btn-color)" }}>
                      {fmtAmt(totalAmt)} {contractCurrency}
                    </span>
                  </div>

                  {/* Real-time over-100% warning */}
                  {(youPct + coPayerTotal) > 100 && (
                    <div style={{ marginTop: 8, padding: "9px 13px", background: "rgba(239,68,68,.08)", border: "1px solid rgba(239,68,68,.25)", borderRadius: 8, fontSize: 12, color: "#ef4444", display: "flex", alignItems: "center", gap: 8 }}>
                      <i className="fas fa-exclamation-circle" style={{ flexShrink: 0 }} />
                      Combined contributions exceed 100% by {((youPct + coPayerTotal) - 100) % 1 === 0 ? (youPct + coPayerTotal) - 100 : ((youPct + coPayerTotal) - 100).toFixed(2)}%. Reduce one or more contributions before continuing.
                    </div>
                  )}
                  {/* Real-time under-100% warning */}
                  {(youPct + coPayerTotal) > 0 && (youPct + coPayerTotal) < 100 && (
                    <div style={{ marginTop: 8, padding: "9px 13px", background: "rgba(245,158,11,.08)", border: "1px solid rgba(245,158,11,.25)", borderRadius: 8, fontSize: 12, color: "#f59e0b", display: "flex", alignItems: "center", gap: 8 }}>
                      <i className="fas fa-exclamation-circle" style={{ flexShrink: 0 }} />
                      Total allocation is {fmtPct(youPct + coPayerTotal)}% — must reach 100% before funding.
                    </div>
                  )}
                </div>

                {/* Email notice */}
                {payers.length > 0 && (
                  <div style={{ marginTop: 14, padding: "11px 14px", background: "color-mix(in srgb, #10b981 8%, transparent)", border: "1px solid color-mix(in srgb, #10b981 25%, transparent)", borderRadius: 8, display: "flex", alignItems: "flex-start", gap: 10 }}>
                    <i className="fas fa-envelope" style={{ fontSize: 14, color: "#10b981", marginTop: 1, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#10b981", marginBottom: 3 }}>Payers Will Be Notified by Email</div>
                      <div style={{ fontSize: 12, color: "var(--text-color)", opacity: .7, lineHeight: 1.5 }}>
                        {payers.length === 1 ? "1 payer" : `${payers.length} payers`} will receive an email invitation to pay their share of the escrow.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ── Section 4: Your Payment ── */}
            {totalAmt > 0 && !myPayerIsFunded && (
              <div className="ecf-section">
                <div className="ecf-section-hdr">
                  <p className="ecf-section-title">
                    <i className="fas fa-credit-card" style={{ fontSize: 11 }} /> Your Payment
                  </p>
                </div>
                <div className="ecf-fund-grid">
                  {FUND_METHODS.map((m) => (
                    <label
                      key={m.key}
                      className={`ecf-fund-card${fundMethod === m.key ? " selected" : ""}`}
                      style={{ "--ecf-fund-color": m.color }}
                      onClick={() => setFundMethod(m.key)}
                    >
                      <input type="radio" name="fundMethod" value={m.key} checked={fundMethod === m.key} onChange={() => setFundMethod(m.key)} />
                      <div className="ecf-fund-card-check">
                        {fundMethod === m.key && <i className="fas fa-check" />}
                      </div>
                      <div className="ecf-fund-card-icon">
                        {m.logo ? <img src={m.logo} alt={m.title} style={{ width: 32, height: 32, objectFit: "contain" }} /> : <i className={m.icon} />}
                      </div>
                      <div className="ecf-fund-card-title">{m.title}</div>
                      <div className="ecf-fund-card-desc">{m.desc}</div>
                    </label>
                  ))}
                </div>

                {errors.fundMethod && (
                  <span className="ecf-err" style={{ marginTop: 12, display: "block" }}>{errors.fundMethod}</span>
                )}

                {/* Fee breakdown */}
                {feeLoading && (
                  <div className="ecf-fee-loader">
                    <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 11 }} />
                    Calculating fees…
                  </div>
                )}
                {feeError && !feeLoading && (
                  <div style={{ marginTop: 12, padding: "10px 13px", background: "rgba(239,68,68,.07)", border: "1px solid rgba(239,68,68,.22)", borderRadius: 9, fontSize: 12, color: "#ef4444", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fas fa-exclamation-circle" style={{ flexShrink: 0 }} />
                    {feeError}
                  </div>
                )}
                {feeData && !feeLoading && (() => {
                  const base = payerBase;
                  return (
                    <div className="ecf-fee-box">
                      <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                      <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                      <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                      <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(base + feeData.calculatedFee)} {contractCurrency}</span></div>
                    </div>
                  );
                })()}

              </div>
            )}

            {/* Footer */}
            {!myPayerIsFunded && (
              <div className="ecf-footer">
                {!anyPayerFunded && (
                  <button
                    className="ecf-btn-draft"
                    onClick={handleSaveDraft}
                    disabled={apiLoading || totalAmt <= 0 || (youPct + coPayerTotal) > 100}
                  >
                    <i className={`fas ${apiLoading ? "fa-spinner fa-spin" : "fa-save"}`} style={{ fontSize: 12 }} />
                    {apiLoading ? "Saving…" : "Save as Draft"}
                  </button>
                )}
                <button
                  className="ecf-btn-fund"
                  onClick={handleFund}
                  disabled={apiLoading || feeLoading || (contractStatus !== "PARTIALLY_FUNDED" && (!!feeError || totalAmt <= 0 || (youPct + coPayerTotal) !== 100))}
                >
                  <i className={`fas ${feeLoading ? "fa-circle-notch fa-spin" : "fa-wallet"}`} style={{ fontSize: 13 }} />
                  {feeLoading ? "Calculating fees…" : "Fund Escrow"}
                </button>
              </div>
            )}

          </div>
          <Footer />
        </div>
      </div>

      {/* Confirm modal */}
      <div className={`ecf-confirm-bg${showConfirm ? " open" : ""}`}>
        <div className="ecf-confirm-box">
          <div className="ecf-confirm-icon">
            <i className="fas fa-wallet" />
          </div>
          <p className="ecf-confirm-title">Confirm &amp; Fund Escrow</p>
          <p className="ecf-confirm-msg">
            You are about to fund contract <strong>#{contractId}</strong>. Your payable amount is{" "}
            <strong>{fmtMoney(payerBase)}</strong>.{" "}
            {payers.length > 0
              ? `You and ${payers.length} payer${payers.length > 1 ? "s" : ""} will be charged their respective shares.`
              : "Your payment will be processed immediately."}{" "}
            All parties will be notified. This action cannot be undone.
          </p>
          <div className="ecf-confirm-terms">
            <input
              type="checkbox"
              id="ecf-terms-cb"
              checked={termsAccepted}
              onChange={e => setTermsAccepted(e.target.checked)}
            />
            <label htmlFor="ecf-terms-cb">
              I agree to the{" "}
              <a href="https://www.paybito.com/escrow/payer-terms" target="_blank" rel="noopener noreferrer">Payer Terms</a>,{" "}
              <a href="https://www.paybito.com/merchants-using-pay-services-terms-of-use/" target="_blank" rel="noopener noreferrer">Merchant Terms</a>,{" "}
              and{" "}
              <a href="https://www.paybito.com/exchange-fees/" target="_blank" rel="noopener noreferrer">Fee Schedule</a>.
            </label>
          </div>
          <div className="ecf-confirm-actions">
            <button className="ecf-confirm-cancel-btn" onClick={() => { setShowConfirm(false); setTermsAccepted(false); }}>Cancel</button>
            <button className="ecf-confirm-ok-btn" onClick={handleConfirm} disabled={!termsAccepted}>
              Confirm &amp; Submit
            </button>
          </div>
        </div>
      </div>

      {/* Crypto selection modal */}
      <div className={`ecf-crypto-bg${showCryptoModal ? " open" : ""}`}>
        <div className="ecf-crypto-modal-box">
          {/* Header */}
          <div className="ecf-crypto-modal-header">
            <p className="ecf-crypto-modal-title">
              <i className="fas fa-coins" style={{ color: "#2563eb" }} />
              Pay with Crypto
            </p>
            <button className="ecf-crypto-modal-close" onClick={() => setShowCryptoModal(false)} disabled={depositAddressLoading}>
              <i className="fas fa-times" />
            </button>
          </div>

          {/* Amount row */}
          <div className="ecf-paypal-amount-row">
            <span className="ecf-paypal-amount-label">Payment Amount</span>
            <span className="ecf-paypal-amount-value">
              {fmtAmt(payerBase)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
            </span>
          </div>

          {/* Coin list */}
          <div className="ecf-net-title" style={{ marginTop: 4, marginBottom: 8 }}>Select Cryptocurrency</div>
          {cryptoListLoading ? (
            <div style={{ textAlign: "center", padding: "28px 0", fontSize: 13, color: "var(--text-color)", opacity: .55 }}>
              <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }} />
              Loading currencies…
            </div>
          ) : (
            <div className="ecf-coin-list">
              {(cryptoList.length > 0 ? cryptoList : CRYPTO_MASTER_LIST).map((coin) => {
                const isSelected = selectedCrypto === coin.currency_code;
                return (
                  <div
                    key={coin.currency_code}
                    className={`ecf-coin-row${isSelected ? " selected" : ""}`}
                    onClick={() => setSelectedCrypto(isSelected ? "" : coin.currency_code)}
                  >
                    <img
                      src={coin.logo}
                      alt={coin.currency_code}
                      className="ecf-coin-logo"
                      onError={(e) => { e.target.style.display = "none"; }}
                    />
                    <div className="ecf-coin-info">
                      <div className="ecf-coin-code">{coin.currency_code}</div>
                      <div className="ecf-coin-name">{coin.currency_name}</div>
                    </div>
                    <div className="ecf-coin-radio">
                      {isSelected && <i className="fas fa-check" style={{ fontSize: 7, color: "#fff" }} />}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Network selector — only for USDT / USDC */}
          {needsNetwork && selectedCrypto && (
            <div className="ecf-net-section">
              <div className="ecf-net-title">Select Network</div>
              <div className="ecf-net-opts">
                {(
                  (cryptoList.find((c) => c.currency_code === selectedCrypto) ||
                   CRYPTO_MASTER_LIST.find((c) => c.currency_code === selectedCrypto))
                    ?.network ?? []
                ).map((n) => ({ key: n, name: n === "ERC" ? "ERC-20" : "TRC-20", desc: n === "ERC" ? "Ethereum network" : "Tron network" })).map((net) => (
                  <label key={net.key} className="ecf-net-opt">
                    <input
                      type="radio"
                      name="cryptoModalNetwork"
                      value={net.key}
                      checked={selectedNetwork === net.key}
                      onChange={() => setSelectedNetwork(net.key)}
                    />
                    <div>
                      <div className="ecf-net-opt-name">{net.name}</div>
                      <div className="ecf-net-opt-desc">{net.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* Converted equivalent amount */}
          {selectedCrypto && (!needsNetwork || selectedNetwork) && (
            <div className="ecf-crypto-equiv-box">
              <span className="ecf-crypto-equiv-label">
                Equivalent in {selectedCrypto}{selectedNetwork ? ` (${selectedNetwork === "ERC" ? "ERC-20" : "TRC-20"})` : ""}
              </span>
              {cryptoPriceLoading ? (
                <span className="ecf-crypto-spinner" />
              ) : cryptoConvertedAmt ? (
                <span className="ecf-crypto-equiv-val">{cryptoConvertedAmt} {selectedCrypto}</span>
              ) : (
                <span style={{ fontSize: 13, color: "var(--text-color)", opacity: .4 }}>—</span>
              )}
            </div>
          )}

          {/* Submit */}
          <button
            className="ecf-crypto-proceed-btn"
            onClick={handleCryptoSubmit}
            disabled={depositAddressLoading || !selectedCrypto || (needsNetwork && !selectedNetwork)}
          >
            {depositAddressLoading ? (
              <><i className="fas fa-spinner fa-spin" style={{ fontSize: 13 }} /> Fetching Address…</>
            ) : (
              <><i className="fas fa-wallet" style={{ fontSize: 13 }} /> Get Receiving Address</>
            )}
          </button>
        </div>
      </div>

      {/* Bank Transfer popup modal */}
      <div className={`ecf-bank-bg${showBankModal ? " open" : ""}`}>
        <div className="ecf-bank-box">
          <div className="ecf-bank-modal-header">
            <p className="ecf-bank-modal-title">
              <i className="fas fa-university" style={{ color: "#e03535" }} />
              Bank Transfer Details
            </p>
            <button className="ecf-bank-modal-close" onClick={() => { setShowBankModal(false); history.push("/escrow/payer/contracts"); }}>
              <i className="fas fa-times" />
            </button>
          </div>

          {(() => {
            const base = payerBase;
            const total = base + (feeData?.calculatedFee || 0);
            return (
              <>
                <div className="ecf-paypal-amount-row" style={{ marginBottom: feeData ? 10 : 18 }}>
                  <span className="ecf-paypal-amount-label">Amount to Transfer</span>
                  <span className="ecf-paypal-amount-value">
                    {fmtAmt(total)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
                  </span>
                </div>
                {feeData && (
                  <div className="ecf-fee-box" style={{ marginBottom: 18 }}>
                    <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                    <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                  </div>
                )}
              </>
            );
          })()}

          <div className="ecf-bank-notice">
            <p className="ecf-bank-notice-title">
              <i className="fas fa-info-circle" style={{ fontSize: 12 }} />
              This is the amount in {contractCurrency} you must transfer.
            </p>
            <ul className="ecf-bank-notice-list">
              <li>The amount displayed here must reach us in full to avoid delays in processing.</li>
              <li>Bank charges or platform rate adjustment must be made at your end.</li>
              <li>Your Escrow contract will be funded as soon as the transfer reaches us.</li>
            </ul>
          </div>

          <p className="ecf-bank-details-title" style={{ marginTop: 14 }}>
            <i className="fas fa-university" style={{ fontSize: 11 }} />
            Make the transfer to the bank given below.
          </p>

          {bankDetailsLoading ? (
            <div style={{ textAlign: "center", padding: "24px 0", fontSize: 13, color: "var(--text-color)", opacity: .55 }}>
              <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }} />
              Loading bank details…
            </div>
          ) : bankDetails?.length > 0 ? (
            bankDetails.map((bd, idx) => (
              <div key={bd.bankId || idx}>
                {bankDetails.length > 1 && (
                  <p style={{ fontWeight: 600, fontSize: 13, margin: idx === 0 ? "0 0 6px" : "16px 0 6px" }}>
                    Bank {idx + 1}: {bd.bankName}
                  </p>
                )}
                <table className="ecf-bank-table">
                  <tbody>
                    {(bd.beneficiaryName || bd.benificiaryName) && (
                      <tr><td>Beneficiary Name</td><td>{bd.beneficiaryName || bd.benificiaryName}</td></tr>
                    )}
                    {bd.beneficiaryAddress && (
                      <tr><td>Beneficiary Address</td><td>{bd.beneficiaryAddress}</td></tr>
                    )}
                    {bd.bankName && (
                      <tr><td>Bank Name</td><td>{bd.bankName}</td></tr>
                    )}
                    {bd.bankAddress && (
                      <tr><td>Bank Address</td><td>{bd.bankAddress}</td></tr>
                    )}
                    {bd.accountNo && (
                      <tr><td>Account No</td><td>{bd.accountNo}</td></tr>
                    )}
                    {bd.accountType && (
                      <tr><td>Account Type</td><td>{bd.accountType}</td></tr>
                    )}
                    {bd.routingNo && (
                      <tr><td>Routing No</td><td>{bd.routingNo}</td></tr>
                    )}
                    {bd.swiftCode && (
                      <tr><td>Swift Code</td><td>{bd.swiftCode}</td></tr>
                    )}
                    {bd.ifscCode && (
                      <tr><td>IFSC Code</td><td>{bd.ifscCode}</td></tr>
                    )}
                    {bd.intermediaryBankName && (
                      <tr><td>Intermediary Bank Name</td><td>{bd.intermediaryBankName}</td></tr>
                    )}
                    {bd.intermediaryBankSwiftCode && (
                      <tr><td>Intermediary Bank Swift Code</td><td>{bd.intermediaryBankSwiftCode}</td></tr>
                    )}
                    {bd.note && (
                      <tr>
                        <td>Note</td>
                        <td>
                          {/<[a-z][\s\S]*>/i.test(bd.note)
                            ? <span dangerouslySetInnerHTML={{ __html: bd.note }} />
                            : bd.note}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "var(--text-color)", opacity: .45 }}>
              <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />
              Bank details not available.
            </div>
          )}

          <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
            <button className="ecf-confirm-cancel-btn" onClick={() => { setShowBankModal(false); history.push("/escrow/payer/contracts"); }}>
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Deposit Address modal */}
      {(() => {
        const coinObj =
          cryptoList.find((c) => c.currency_code === selectedCrypto) ||
          CRYPTO_MASTER_LIST.find((c) => c.currency_code === selectedCrypto);
        const networkLabel =
          selectedNetwork === "ERC" ? "ERC-20" :
          selectedNetwork === "TRC" ? "TRC-20" : null;
        const qrUrl = depositAddress
          ? `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(depositAddress)}`
          : null;
        return (
          <div className={`ecf-addr-bg${showAddressModal ? " open" : ""}`}>
            <div className="ecf-addr-box">
              {/* Header */}
              <div className="ecf-addr-header">
                <p className="ecf-addr-title">
                  <i className="fas fa-wallet" style={{ color: "#2563eb" }} />
                  Deposit Address
                </p>
                <button className="ecf-addr-close" onClick={() => setShowAddressModal(false)}>
                  <i className="fas fa-times" />
                </button>
              </div>

              {addrPaymentStatus === "SUCCESS" ? (
                <div className="ecf-addr-success">
                  <div className="ecf-addr-success-icon">
                    <i className="fas fa-check" />
                  </div>
                  <p className="ecf-addr-success-title">Payment Successfully Received!</p>
                  <p className="ecf-addr-success-sub">
                    Your crypto payment has been confirmed on the blockchain.
                    The escrow contract will now be activated.
                  </p>
                  <button
                    className="ecf-addr-success-btn"
                    onClick={() => {
                      setShowAddressModal(false);
                      setShowCryptoModal(false);
                      setSubmitted(true);
                    }}
                  >
                    <i className="fas fa-check" style={{ fontSize: 13 }} />
                    Payment has been received
                  </button>
                </div>
              ) : (
              <>

              {/* Selected coin info */}
              {coinObj && (
                <div className="ecf-addr-coin-row">
                  <img
                    src={coinObj.logo}
                    alt={coinObj.currency_code}
                    className="ecf-addr-coin-logo"
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                  <div>
                    <div className="ecf-addr-coin-name">
                      {coinObj.currency_name}
                      {networkLabel && <span className="ecf-addr-coin-network">{networkLabel}</span>}
                    </div>
                    <div style={{ fontSize: 11, color: "var(--text-color)", opacity: .5, marginTop: 2 }}>
                      {coinObj.currency_code}
                    </div>
                  </div>
                </div>
              )}

              {/* Amount to send */}
              {(() => {
                const base = payerBase;
                const total = base + (feeData?.calculatedFee || 0);
                return (
                  <>
                    <div className="ecf-addr-amt-row" style={{ marginBottom: feeData ? 10 : 18 }}>
                      <span className="ecf-addr-amt-label">Amount to Send</span>
                      <span className="ecf-addr-amt-val">
                        {cryptoConvertedAmt
                          ? `${cryptoConvertedAmt} ${selectedCrypto}`
                          : `${fmtAmt(total)} ${contractCurrency}`}
                      </span>
                    </div>
                    {feeData && !cryptoConvertedAmt && (
                      <div className="ecf-fee-box" style={{ marginBottom: 18 }}>
                        <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                        <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                        <div className="ecf-fee-row ecf-fee-total"><span>Total to Send</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                      </div>
                    )}
                  </>
                );
              })()}

              {/* QR Code */}
              {qrUrl && (
                <div className="ecf-addr-qr-wrap">
                  <img src={qrUrl} alt="Deposit QR Code" className="ecf-addr-qr" />
                </div>
              )}

              {/* Receiving address with copy */}
              <div className="ecf-addr-field-label">Receiving Address</div>
              {depositAddress ? (
                <div className={`ecf-addr-copy-row${addressCopied ? " copied" : ""}`}>
                  <span className="ecf-addr-text">{depositAddress}</span>
                  <button
                    className={`ecf-addr-copy-btn${addressCopied ? " copied" : ""}`}
                    onClick={() => {
                      navigator.clipboard.writeText(depositAddress).then(() => {
                        setAddressCopied(true);
                        setTimeout(() => setAddressCopied(false), 2500);
                      });
                    }}
                  >
                    <i className={`fas ${addressCopied ? "fa-check" : "fa-copy"}`} style={{ fontSize: 11 }} />
                    {addressCopied ? "Copied!" : "Copy"}
                  </button>
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "18px 0", fontSize: 13, color: "var(--text-color)", opacity: .45 }}>
                  <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />
                  Address not available. Please contact support.
                </div>
              )}

              {/* Memo / Destination Tag — XRP and HCX only */}
              {(selectedCrypto === "XRP" || selectedCrypto === "HCX") && depositMemo && (
                <>
                  <div className="ecf-addr-field-label" style={{ marginTop: 14 }}>
                    Memo / Destination Tag
                  </div>
                  <div className={`ecf-addr-copy-row${memoCopied ? " copied" : ""}`}>
                    <span className="ecf-addr-text">{depositMemo}</span>
                    <button
                      className={`ecf-addr-copy-btn${memoCopied ? " copied" : ""}`}
                      onClick={() => {
                        navigator.clipboard.writeText(depositMemo).then(() => {
                          setMemoCopied(true);
                          setTimeout(() => setMemoCopied(false), 2500);
                        });
                      }}
                    >
                      <i className={`fas ${memoCopied ? "fa-check" : "fa-copy"}`} style={{ fontSize: 11 }} />
                      {memoCopied ? "Copied!" : "Copy"}
                    </button>
                  </div>
                  <div style={{ marginTop: 8, padding: "8px 12px", background: "rgba(239,68,68,.07)", border: "1px solid rgba(239,68,68,.2)", borderRadius: 8, fontSize: 12, color: "#ef4444", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fas fa-exclamation-circle" style={{ flexShrink: 0, marginTop: 0 }} />
                    <span>You <strong>must</strong> include this memo when sending. Transactions without the correct memo may be lost.</span>
                  </div>
                </>
              )}

              {/* Warning */}
              <div className="ecf-addr-notice">
                <i className="fas fa-exclamation-triangle" style={{ color: "#f59e0b", flexShrink: 0, marginTop: 1 }} />
                <span>
                  Send only <strong>{selectedCrypto}</strong>{networkLabel ? ` (${networkLabel})` : ""} to this address.
                  Sending any other asset may result in <strong>permanent loss of funds</strong>.
                </span>
              </div>

              {/* Countdown */}
              <div className="ecf-addr-countdown">
                <span className="ecf-addr-countdown-text">
                  <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 11 }} />
                  Checking payment status in
                </span>
                <span className="ecf-addr-countdown-num">{addrCountdown}s</span>
              </div>

              </>
              )}
            </div>
          </div>
        );
      })()}

      {/* PayPal popup modal */}
      <div className={`ecf-paypal-bg${showPaypalModal ? " open" : ""}`}>
        <div className="ecf-paypal-box">
          <div className="ecf-paypal-header">
            <p className="ecf-paypal-title">
              <img src="https://www.paypalobjects.com/webstatic/icon/pp258.png" alt="PayPal" style={{ width: 22, height: 22, objectFit: "contain" }} />
              Pay with PayPal
            </p>
            <button className="ecf-paypal-close" onClick={() => setShowPaypalModal(false)}>
              <i className="fas fa-times" />
            </button>
          </div>

          {(() => {
            const base = payerBase;
            const total = base + (feeData?.calculatedFee || 0);
            return (
              <>
                <div className="ecf-paypal-amount-row" style={{ marginBottom: feeData ? 10 : 20 }}>
                  <span className="ecf-paypal-amount-label">Payment Amount</span>
                  <span className="ecf-paypal-amount-value">
                    {fmtAmt(total)} <span style={{ fontSize: 13, fontWeight: 600, opacity: .55 }}>{contractCurrency}</span>
                  </span>
                </div>
                {feeData && (
                  <div className="ecf-fee-box" style={{ marginBottom: 20 }}>
                    <div className="ecf-fee-header"><i className="fas fa-receipt" style={{ fontSize: 10 }} /> Fee Breakdown</div>
                    <div className="ecf-fee-row"><span>Amount</span><span>{fmtAmt(base)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row"><span>Escrow Fee</span><span>{fmtAmt(feeData.calculatedFee)} {contractCurrency}</span></div>
                    <div className="ecf-fee-row ecf-fee-total"><span>Total to Pay</span><span>{fmtAmt(total)} {contractCurrency}</span></div>
                  </div>
                )}
              </>
            );
          })()}

          {showPaypalModal && totalAmt > 0 && (
            <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, currency: contractCurrency }}>
              <PayPalButtons
                style={{ layout: "vertical", color: "blue", shape: "rect", label: "pay", height: 45 }}
                createOrder={(_data, actions) =>
                  actions.order.create({
                    purchase_units: [{
                      amount: {
                        value: ((payerBase) + (feeData?.calculatedFee || 0)).toFixed(2),
                        currency_code: contractCurrency,
                      },
                      description: `Escrow Contract #${contractId}`,
                    }],
                  })
                }
                onApprove={(_data, actions) =>
                  actions.order.capture().then((captureResult) => handlePayPalApprove(_data, captureResult))
                }
                onError={() => showToast("error", "PayPal payment failed. Please try again.")}
                onCancel={() => setShowPaypalModal(false)}
              />
            </PayPalScriptProvider>
          )}
        </div>
      </div>
    </Fragment>
  );
}
